// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-26T14:38:21.440Z
// Property: Homestead (ID: 6767906449167743)
// Collections: 42 amenities, 15 floorplans (live), 52 photos, 74 POIs, 5 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167743",
  "property_external_id": "3ghgh3f",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/the-reve-garland-tx/3ghgh3f/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "homestead",
  "property_name": "Homestead",
  "property_website_url": "https://demo-homestead-template.multiscreensite.com/",
  "property_domain": null,
  "property_address": "100 Peachtree St",
  "property_full_address": "100 Peachtree St",
  "property_address_1": "100 Peachtree St",
  "property_address_2": null,
  "property_address_city": "Atlanta",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "12345",
  "property_address_country": "US",
  "property_address_county": "Peachtree County",
  "property_neighborhood_address": "Atlanta",
  "property_address_latitude": "32.9721207",
  "property_address_longitude": "-96.6573002",
  "property_email": null,
  "property_phone": "123-456-7890",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Come home to extraordinary.</strong> Studio, one, two, and three bedroom pet-friendly apartments near Downtown Atlanta pair elegant designer finishes with resort-caliber amenities and standout access to Atlanta destinations.</p>",
  "property_long_description": "<p>Up-end the ordinary with a new studio, one, two, or three bedroom apartments at Homestead. These pet-friendly apartments near Downtown Atlanta will make each day something special, with resort-caliber amenities, elegant designer finishes, and apartment features that rival any five-star hotel. All with unrivaled access to Atlanta's best destinations and beyond. Come home to extraordinary – live, love, Homestead.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
    "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
    "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
    "width": 1728,
    "height": 1152
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "225",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.22222222222221",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "We happily accept up to 2 pets per apartment home.",
  "property_pet_policy_description": "We happily accept up to 2 pets per apartment home. Non‑Refundable Pet Fee: $300 per pet. Monthly pet rent: $20 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e59-8fa6-75b1-b72c-ab1df83e786d.webp",
  "property_primary_logo_media": {
    "alt_text": "Homestead logo",
    "public_id": "01a03e59-8fa6-75b1-b72c-ab1df83e786d",
    "storage_key": "property/6767906449167743/01a03e59-8fa6-75b1-b72c-ab1df83e786d.webp",
    "width": 500,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-6ac1-7735-a710-f08a36e29fde.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a03e5a-6ac1-7735-a710-f08a36e29fde",
    "storage_key": "property/6767906449167743/01a03e5a-6ac1-7735-a710-f08a36e29fde.webp",
    "width": 500,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-61c2-77fd-bb39-e3eeeea50bd7.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03e5a-61c2-77fd-bb39-e3eeeea50bd7",
    "storage_key": "property/6767906449167743/01a03e5a-61c2-77fd-bb39-e3eeeea50bd7.webp",
    "width": 500,
    "height": 150
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#244c5a",
  "property_secondary_color": "#94b7bb",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 3",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 3",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "3",
  "property_sqft_range": "663 - 1,476 sq ft",
  "property_sqft_min": "663",
  "property_sqft_max": "1,476",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 13,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJe7ZHyDQdTIYR0a4CjIE1-BI",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Homestead",
  "property_home_romance_title": "Find Your Perfect Sanctuary in Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Polished amenities, effortless routines.</strong> Homestead pairs resort-style relaxation with everyday convenience, from the pool, fitness center, yoga and spin room to grilling areas, a clubhouse, business center, and firepit lounge. Inside, granite countertops, stainless steel appliances, tile backsplashes, in-home washers and dryers, USB charging ports, and walk-in closets keep things streamlined. Pet-friendly perks, covered parking options, storage, door-to-door trash pickup, and a 24-hour package system add even more ease.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room for your routine.</strong><br>Explore studio, one-, two-, and three-bedroom apartments in Garland with open-concept kitchens, granite countertops, stainless steel appliances, custom tile backsplashes, in-home washers and dryers, and generous walk-in closets. Select layouts add kitchen islands, balconies, extra bedrooms, or additional baths, giving you more ways to match your space to your day.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Homestead.</strong> Preview bright kitchens with granite countertops, stainless steel appliances, custom tile backsplashes, and hardwood-inspired flooring, plus thoughtful touches like in-home washers and dryers, USB charging ports, generous closets, and select balconies. Then browse the community spaces, from the sparkling pool and fitness studio to the yoga and spin room, clubhouse, grilling areas, firepit lounge, bark park, and pet spa.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Trail time meets town-center energy.</strong> From Homestead, Garland opens up with shaded paths at Spring Creek Forest Preserve, shopping and dining at Firewheel Town Center, and movie nights at AMC Firewheel 18. Downtown Garland adds coffee, barbecue, live theater, and Blue Line access, while President George Bush Turnpike keeps Richardson, Plano, and Dallas easy to reach. Explore the neighborhood and see how connected home can feel.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents point to the details that make Homestead feel easy to enjoy.</strong> Reviews call out nice apartments with high ceilings, good-sized patios, quick maintenance, and a management team that keeps things moving smoothly. One longtime resident summed it up simply: “I’m happy here.” Read more to see what everyday living at Homestead in Garland is like.</p>",
  "property_neighborhood_blurb": "<p><strong>Trail time, town-center energy, and easy DFW connections.</strong> Around Homestead, your Garland map opens in every direction: shaded paths through Spring Creek Forest Preserve, open-air shopping and dinner at Firewheel Town Center, and quick movie nights at AMC Firewheel 18. Keep weekends local with Ferah Tex-Med Kitchen or Wildwood Firewheel, then head toward Downtown Garland for Rosalind Coffee, Intrinsic Smokehouse &amp; Brewery, the Plaza Theatre, and the Blue Line from Downtown Garland Station. President George Bush Turnpike keeps Richardson, Plano, and Dallas within reach, while home gives you a polished place to reset between outings. Explore the map, picture your daily routes, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Homestead’s location in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep pace with your day.</strong> At Homestead, polished interiors and inviting shared spaces work together to make home feel effortless. Start with a resort-style pool, fitness center, yoga and spin room, clubhouse, business center, and outdoor spaces built for grilling, gathering, or unwinding by the firepit.</p><p>Inside your apartment, modern finishes add everyday function without losing style: sleek granite countertops, stainless steel appliances, custom-patterned tile backsplashes, hardwood-inspired flooring, in-home washers and dryers, USB charging ports, and generous walk-in closets. Pet-friendly perks like the bark park and posh pet spa add another layer of convenience, while key fob entry, door-to-door trash pickup, covered parking options, storage units, and a 24-hour package system help simplify the routine. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in action.</p>",
  "property_applynow_blurb": "<p><strong>Come home to extraordinary.</strong> Start your online application for a studio, one, two, or three bedroom apartment at The ReVe, where pet-friendly living, designer finishes, and resort-caliber amenities up-end the ordinary near Richardson. Apply now and take the next step toward your new home in Garland.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Reach out to the leasing team at The ReVe and let us help you explore studio, one, two, and three bedroom apartments with pet-friendly living, elegant finishes, and resort-caliber amenities near Richardson. Come home to extraordinary.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life here?</strong> Start here for quick answers about the community, leasing, apartment options, pet-friendly living, and what to expect at these studio, one, two, and three bedroom apartments near Richardson. If you need more details, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that feels right from the first walkthrough.</strong><br>Homestead gives you a wide range of studio, one-, two-, and three-bedroom apartments in Garland, from streamlined spaces with smart storage to roomier floor plans with extra bedrooms and baths. As you compare available homes, look for the details that make everyday living easier: open-concept kitchens, sleek granite countertops, stainless steel appliances, custom-patterned tile backsplashes, in-home washers and dryers, and generous walk-in closets.</p><p>Select layouts add the little extras that can shape your routine, like kitchen islands for prep space or balconies for fresh air between tasks. Browse current pricing and availability, view the finishes in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which floor plan fits the way you like to live.</p>",
  "property_gallery_blurb": "<p><strong>See Homestead from every angle.</strong> Browse photos that bring the details into focus, from bright kitchens with granite countertops, stainless steel appliances, and custom-patterned tile backsplashes to open living areas with hardwood-inspired flooring and room to make each layout your own. Look for everyday conveniences captured throughout the gallery, including in-home washers and dryers, generous closets, USB charging ports, and select balconies.</p><p>Then step into the shared spaces that shape the community’s look and feel: a sparkling pool, fitness studio, yoga and spin room, clubhouse seating, outdoor grilling areas, firepit lounge, and pet-friendly spots like the bark park and spa. After you explore the images, compare <a href=\"/floor-plans\">studio to three-bedroom layouts</a>, take a closer look at the <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Homestead in Garland in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore what’s around The ReVe.</strong> Use the interactive map to browse available studio, one, two, and three bedroom apartments, then see how this Garland address connects you to nearby Richardson and the area’s best destinations.</p>",
  "property_pets_blurb": "<p><strong>Pet routines feel easier when the essentials are built in.</strong> At Homestead, your approved companion has more than a place to live—there’s space for quick outdoor breaks, a Bark Park for playtime, and a Posh Pet Spa with a pet washing station to make cleanup simple after muddy paws or rainy walks.</p><p>Inside your apartment, hardwood-inspired flooring, in-home laundry, generous storage, and select balconies add practical comfort between outings. Nearby pet-care options and off-leash destinations in Atlanta help round out the routine, while the policy details below make it easy to plan your next step. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/contact-us\">contact the leasing team</a> with questions about guidelines for your pet.</p>",
  "property_referafriend_blurb": "<p><strong>Share the extraordinary.</strong> Love the resort-caliber amenities, elegant designer finishes, pet-friendly spaces, and access to Garland’s best destinations? Invite a friend to experience studio, one, two, or three bedroom living at The ReVe—and make everyday living feel anything but ordinary.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The ReVe</strong><br>Keep everyday details effortless. Log in to pay rent, submit maintenance requests, and manage your account—then get back to enjoying pet-friendly apartment living with elegant finishes, resort-caliber style, and Garland access that keeps life moving.</p>",
  "property_reviews_blurb": "<p><strong>Hear what life at Homestead feels like from the people who know it firsthand.</strong> Resident feedback highlights the everyday details that make a difference: a nice apartment, high ceilings, a good-sized patio, responsive maintenance, and a management team that keeps things running smoothly.</p><p>One long-term resident shared, “I’m happy here,” noting five years at Homestead with quick maintenance and no issues with management. As you browse the reviews, you’ll find practical insight into the living experience at Homestead in Garland.</p>",
  "property_created_at": "1787752414793",
  "property_scheduletour_blurb": "<p><strong>See extraordinary up close.</strong> Tour The ReVe and experience pet-friendly studio, one, two, and three bedroom apartments with elegant designer finishes, resort-caliber amenities, and five-star-inspired features. Schedule your visit today and picture what home can feel like in Garland.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out.</strong> Your inquiry was received, and the leasing team will follow up soon. In the meantime, explore studio, one, two, and three bedroom <a href=\"/floor-plans\">floor plans</a> with pet-friendly living, designer finishes, and resort-caliber <a href=\"/amenities\">amenities</a> near Richardson.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Homestead’s virtual tours let you move through the spaces at your own pace, zooming in on the details that matter: open kitchens with granite countertops and stainless steel appliances, hardwood-inspired flooring, in-home laundry, walk-in closet space, and the flow between living, dining, and sleeping areas.</p><p>Start with the community tour for a feel for the shared spaces, then explore apartment walkthroughs for the A1 one-bedroom, B1 two-bedroom, and 2BA2 two-bedroom layouts. Compare how each home lives on screen, revisit your favorite views, and when you’re ready for the next step, <a href=\"/schedule-a-tour\">schedule a tour</a> or browse current <a href=\"/floor-plans\">floor plans</a>.</p>",
  "property_copyright": "2026 All Rights Reserved. Homestead",
  "property_seo_title_home": "Homestead |  Apartments in Garland, TX",
  "property_seo_description_home": "Welcome to Homestead in Garland, TX! Explore spacious 1-3 bedroom floor plans with luxurious amenities for modern living. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Garland, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal floor plan at Homestead in Garland, TX. Choose from stylish one, two, or three-bedroom apartments that fit your lifestyle—browse now!",
  "property_seo_title_amenities": "Amenities | Garland, TX Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Homestead in Garland, TX! Enjoy luxurious amenities, from a refreshing pool to a pet spa. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Garland, TX",
  "property_seo_description_gallery": "Imagine life at Homestead in Garland, TX—luxury amenities, stunning floor plans, and vibrant spaces. Your ideal home awaits. Picture yourself living here!",
  "property_seo_title_virtualtours": "Virtual Tours | Homestead Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Homestead in Garland, TX. Take a virtual tour of our stunning one, two, and three-bedroom apartments today! Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Homestead Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Homestead in Garland, TX! Our interactive map unveils stylish one, two, and three-bedroom layouts with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Garland, TX",
  "property_seo_description_neighborhood": "Experience the vibrant life at Homestead in Garland, TX. Immerse yourself in local favorites and uncover nearby gems just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Homestead",
  "property_seo_description_contact": "Live your best life at Homestead in Garland, TX! From cozy one-bedrooms to spacious three-bedrooms, our leasing team is here to answer all your questions!",
  "property_seo_title_faqs": "FAQs | Apartments in Garland, TX",
  "property_seo_description_faqs": "Find answers to your questions about Homestead in Garland, TX! Learn about our amenities, floor plans, and more. Your new home awaits. Visit our FAQs!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Garland, TX",
  "property_seo_description_reviews": "Curious about life at Homestead in Garland, TX? See what our residents are buzzing about—luxury amenities, modern designs, and a vibrant community await!",
  "property_seo_title_applynow": "Apply Now | Apartments in Garland, TX",
  "property_seo_description_applynow": "Elevate your lifestyle at Homestead in Garland, TX! Choose spacious 1-3 bedroom apartments with premium amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Homestead",
  "property_seo_description_residentaccess": "Elevate your living at Homestead in Garland, TX! Log in to access your resident portal for effortless rent payments and hassle-free maintenance requests.",
  "property_seo_title_referafriend": "Refer A Friend | Homestead",
  "property_seo_description_referafriend": "Refer a friend to Homestead in Garland, TX! Great friends make great neighbors—share the joy of our vibrant community and enjoy exclusive rewards together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Homestead",
  "property_seo_description_scheduletour": "Experience vibrant living at Homestead in Garland, TX! Schedule your personalized tour today and see why our community feels just like home.",
  "property_seo_title_privacy": "Privacy Policy | Homestead",
  "property_seo_description_privacy": "At Homestead in Garland, TX, your privacy matters. Review our commitment to keeping your information safe and secure. Click to learn more about our policies.",
  "property_seo_title_accessibility": "Website Accessibility | Homestead",
  "property_seo_description_accessibility": "At Homestead in Garland, TX, we prioritize accessibility for all. Join our community where everyone feels at home! Your comfort is our commitment.",
  "property_seo_title_sitemap": "Sitemap | Homestead",
  "property_seo_description_sitemap": "Navigate your path to urban living at Homestead in Garland, TX. Check out our sitemap for an effortless exploration of our vibrant community and amenities!",
  "property_seo_title_thankyou": "Thank You | Homestead",
  "property_seo_description_thankyou": "Thanks for reaching out! Your interest in Homestead, Garland’s charming apartment community, is appreciated. Expect a team member to connect with you soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Garland, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787754046548",
  "amenities": [
    {
      "id": "ec_0bd4f0c2a61c7ad825a580b0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "24 Hour Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ba5ee528272002122bf2abb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Trash Pickup - Door to Door",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_132d5fd2ec6d65e6430f18e9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_123f961312585b301ed412f2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b37fc226f20d59c835a45e4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Key Fob Entry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31b6f25e8c4dd015f564fa1e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76e71b4e64e8771ddbce1824",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ca52b986ceb38a9f781f44e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f850f9076a4dbd7fbdd222ae",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7981b91c0fe6a1c00dd576e6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e93623cfef373f0c0e26d628",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fe4aa0d6949cb2321e25eff",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5ef5523efe7fb9ca8f79a04",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "24-Hour Resident Package System",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76d6e25caf67c7058fa3a2fc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_308025934f15634641f314b0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Bark Park & Posh Pet Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2cc4530895712bee59d005da",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aef52e416cf24931d8bd5128",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Custom-Patterned Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4439a345d7fa4c5a744d664",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Entry Garages & Covered Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d09fc72812089832af5006a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Generous Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc6a6cae90a0730e36ad1181",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Inspired Luxury Flooring",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd96214ace71a6a8d226ee2f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "In-Home Washer and Dryers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21105f45d1316485669bcaba",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen Islands",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4dc3e0a5213225b7cea63266",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Entertainment Space & Grilling Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e252373f7e66265afbe039b3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Firepit Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87e3d59850b5b24e37e5e422",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Scenic Outdoor & Courtyard Spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc93744bf9310dee6dffeae1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Sleek Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c3b981c4b6eac1477db2b48",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Units",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51874b97ab7c7e8c59d3803d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "USB Charging Ports",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f01551629a52d6e30468651",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "WiFi in Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ea9caca8c10c60791d42357",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Yoga & Spin Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64ed35c40e9c9e99190fa905",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f1f61b86385dcb36b0a44ef",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9de8a120510062b7c83b3195",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_852fd9faf90eb158029ba4f7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8503fc65941438765b0be41",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b05999b2d7485c4c4186b84f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05a809986af81de515e8506e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b5471bc144f68eafd7c5926",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40162db0fcbabe1ee3fc655c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c9623396f6efb92490b74bb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec1ce59898bbc5cc37ced88a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2756d1dd97be2717f811383f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_66472d4a7c6e32deee44f130",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-4ab1-718c-9f32-2435fd1a793c.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a bar area.",
        "public_id": "01a03e5c-4ab1-718c-9f32-2435fd1a793c",
        "storage_key": "property/6767906449167743/01a03e5c-4ab1-718c-9f32-2435fd1a793c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and a vibrant bar area for ultimate relaxation.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a bar area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/KwzY15uwopdcA30y74Kylw7CSlGRl7FpD3RJfYxOpDw/102/image.jpg"
    },
    {
      "id": "ec_22aed9751b5d3208868b8045",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-4ab1-718c-9f32-2435fd1a793c.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a bar area.",
        "public_id": "01a03e5c-4ab1-718c-9f32-2435fd1a793c",
        "storage_key": "property/6767906449167743/01a03e5c-4ab1-718c-9f32-2435fd1a793c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and a vibrant bar area for ultimate relaxation.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a bar area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/KwzY15uwopdcA30y74Kylw7CSlGRl7FpD3RJfYxOpDw/102/image.jpg"
    },
    {
      "id": "ec_306d81cf93a7d574d35dcd96",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-38a8-70b7-a932-0f6b14cb9284.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, granite island, stainless steel appliances, and a view of the living area.",
        "public_id": "01a03e5c-38a8-70b7-a932-0f6b14cb9284",
        "storage_key": "property/6767906449167743/01a03e5c-38a8-70b7-a932-0f6b14cb9284.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring ample cabinet space, a large granite island perfect for entertaining, and stainless steel appliances. This open-concept layout flows seamlessly into the living area.",
      "link": "false",
      "alt_text": "Modern kitchen with gray cabinets, granite island, stainless steel appliances, and a view of the living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/e6YScANr1mk4jZVXHWdwbCgdYg6jFewNBwAalhARpBI/110/image.jpg"
    },
    {
      "id": "ec_f14845ad2645c09e58a865a5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-38ad-77c6-b205-de07ef224d10.webp",
      "image_media": {
        "alt_text": "Modern open-concept kitchen and living area with island seating.",
        "public_id": "01a03e5c-38ad-77c6-b205-de07ef224d10",
        "storage_key": "property/6767906449167743/01a03e5c-38ad-77c6-b205-de07ef224d10.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Expansive open-concept living space featuring a gourmet kitchen with an island and bar seating, adjacent to a comfortable living room.",
      "link": "false",
      "alt_text": "Modern open-concept kitchen and living area with island seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/BHaTlo7MXkOZthceifEXZVJ83nBJl_EU2jp-RrQqTqY/119/image.jpg"
    },
    {
      "id": "ec_25b55ea1cb1ecea03a40415a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-381d-7613-813d-b580b9eb377a.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island seating and natural light",
        "public_id": "01a03e5c-381d-7613-813d-b580b9eb377a",
        "storage_key": "property/6767906449167743/01a03e5c-381d-7613-813d-b580b9eb377a.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with ample counter space, an island with bar seating, and a comfortable living room with natural light.",
      "link": "false",
      "alt_text": "Modern kitchen and living area with island seating and natural light",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4-Vp2VRhUEIpMXB_TVieqg7Mv1kkzKGS_FGANIGuD9M/110/image.jpg"
    },
    {
      "id": "ec_566191815601820a2cd5482d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-4d28-76cd-9f20-91db48c59269.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, granite island, and stainless steel appliances.",
        "public_id": "01a03e5c-4d28-76cd-9f20-91db48c59269",
        "storage_key": "property/6767906449167743/01a03e5c-4d28-76cd-9f20-91db48c59269.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A stylish and modern kitchen featuring sleek gray cabinetry, a spacious granite-topped island with bar seating, and a full suite of stainless steel appliances, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with gray cabinets, granite island, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/XtuGni9aj3_WVmNoI0rGNZ5CcxrGlagPSd3CFfJeDbg/102/image.png"
    },
    {
      "id": "ec_62b675476e184bc952d4a6aa",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-6cfd-71ae-a91d-3814c7614180.webp",
      "image_media": {
        "alt_text": "Modern bedroom with geometric accent wall and plush bedding.",
        "public_id": "01a03e5c-6cfd-71ae-a91d-3814c7614180",
        "storage_key": "property/6767906449167743/01a03e5c-6cfd-71ae-a91d-3814c7614180.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Relax in this stylish bedroom featuring a unique geometric accent wall, a comfortable king-size bed with premium linens, and tasteful decor.",
      "link": "false",
      "alt_text": "Modern bedroom with geometric accent wall and plush bedding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/GvaLCuoxjuSmIFEXdK4l2sO4IuH76cs-V6aDU-KvViU/119/image.png"
    },
    {
      "id": "ec_d61db2503be552fd5f17095c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-67ca-710b-a692-a62b641716a5.webp",
      "image_media": {
        "alt_text": "A resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a03e5c-67ca-710b-a692-a62b641716a5",
        "storage_key": "property/6767906449167743/01a03e5c-67ca-710b-a692-a62b641716a5.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, featuring comfortable lounge chairs and ample shade. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "false",
      "alt_text": "A resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/b1mkoK0xIlGWAFommhBnMw-yKXoIRkAuOzM0RfTELZM/102/image.png"
    },
    {
      "id": "ec_25c1de7cb5c80bba0b8dd18f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-7193-70f9-b1c3-f1e799b56969.webp",
      "image_media": {
        "alt_text": "Modern living room with gray sofa, concrete accent wall, and large TV.",
        "public_id": "01a03e5c-7193-70f9-b1c3-f1e799b56969",
        "storage_key": "property/6767906449167743/01a03e5c-7193-70f9-b1c3-f1e799b56969.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable gray sofa, a unique concrete accent wall, and a large flat-screen TV, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Modern living room with gray sofa, concrete accent wall, and large TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rhpAdgNJQ2W57aWaqgFY5-vr3RY3WD0KKiAiZaDJSBo/118/image.png"
    },
    {
      "id": "ec_278946f639ed82b517a92703",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-7997-7131-aaaa-1106dc9aeab4.webp",
      "image_media": {
        "alt_text": "Spin bikes in a modern fitness center with large windows overlooking the exterior.",
        "public_id": "01a03e5c-7997-7131-aaaa-1106dc9aeab4",
        "storage_key": "property/6767906449167743/01a03e5c-7997-7131-aaaa-1106dc9aeab4.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio equipment like these spin bikes, perfect for a quick workout.",
      "link": "false",
      "alt_text": "Spin bikes in a modern fitness center with large windows overlooking the exterior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qF3tFexwjZiHTkgTupH_0Siwf4ToVLGxWuVWbrG9mvU/102/image.png"
    },
    {
      "id": "ec_e608002c272aca2e657bba92",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-7783-7039-844f-06a95a158d07.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with a playground structure, agility equipment, and a bone-shaped bench.",
        "public_id": "01a03e5c-7783-7039-844f-06a95a158d07",
        "storage_key": "property/6767906449167743/01a03e5c-7783-7039-844f-06a95a158d07.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Our community features a dedicated dog park, complete with agility equipment and a fun playground structure for your furry friends to enjoy.",
      "link": "false",
      "alt_text": "A fenced-in dog park with a playground structure, agility equipment, and a bone-shaped bench.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pHzPG1PIIK4kAth3tAR1zbCyS_XcUuUptvkpVRVdq_4/118/image.jpg"
    },
    {
      "id": "ec_e590a95d68a6adc68c9367a5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-891a-76ca-9c70-6ac9a25363f5.webp",
      "image_media": {
        "alt_text": "Two tiled shower stalls with chrome fixtures and a central grooming station with a scale.",
        "public_id": "01a03e5c-891a-76ca-9c70-6ac9a25363f5",
        "storage_key": "property/6767906449167743/01a03e5c-891a-76ca-9c70-6ac9a25363f5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Clean and functional shower stalls with a central grooming area, perfect for pet washing or resident use. Features dual shower heads and a convenient grooming station.",
      "link": "false",
      "alt_text": "Two tiled shower stalls with chrome fixtures and a central grooming station with a scale.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/nBfGqs5S7KVc0L8ld4HvUvxuEOtUhl2r4EiTaZGLP3s/102/image.jpg"
    },
    {
      "id": "ec_92f10498434de7e8fa54b5e3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-8b8f-759e-aac3-adae59543f6e.webp",
      "image_media": {
        "alt_text": "Open concept living and kitchen area with a kitchen island and bar stools, a living room with a sofa and coffee table, and a balcony view.",
        "public_id": "01a03e5c-8b8f-759e-aac3-adae59543f6e",
        "storage_key": "property/6767906449167743/01a03e5c-8b8f-759e-aac3-adae59543f6e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "This spacious apartment features an open-concept living and kitchen area, perfect for entertaining. Enjoy your morning coffee at the kitchen island or relax in the comfortable living room.",
      "link": "false",
      "alt_text": "Open concept living and kitchen area with a kitchen island and bar stools, a living room with a sofa and coffee table, and a balcony view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OldXds2xlJS3bXtr16tmkSOvSH_BYp79dSaz2Hfoxpc/119/image.png"
    },
    {
      "id": "ec_1827442915a7dcd06c0ea89b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-87ec-779e-a276-ce625f732065.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with tanning ledges and lounge chairs, surrounded by a modern apartment building.",
        "public_id": "01a03e5c-87ec-779e-a276-ce625f732065",
        "storage_key": "property/6767906449167743/01a03e5c-87ec-779e-a276-ce625f732065.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with tanning ledges and comfortable lounge chairs. Enjoy the ultimate in outdoor relaxation at our modern community.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with tanning ledges and lounge chairs, surrounded by a modern apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yazLqb4gYQhYpK6a-H5fMHcmKHtw5GKldSJpvLTuTLU/115/image.png"
    },
    {
      "id": "ec_e0d9e826cf10c36c8a03e2c6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-a0d7-71be-a7e1-b55c45ef577d.webp",
      "image_media": {
        "alt_text": "Convenience store display with snacks, drinks, and a checkout kiosk.",
        "public_id": "01a03e5c-a0d7-71be-a7e1-b55c45ef577d",
        "storage_key": "property/6767906449167743/01a03e5c-a0d7-71be-a7e1-b55c45ef577d.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Fully stocked convenience store featuring a variety of snacks, frozen meals, and beverages, complete with a self-checkout kiosk for resident convenience.",
      "link": "false",
      "alt_text": "Convenience store display with snacks, drinks, and a checkout kiosk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cPSL094CN2XVxUDF8adEsopp5q5-ax0kkTXKHW6VEoc/119/image.png"
    },
    {
      "id": "ec_7fa56c2c653ceff8557150be",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-9ce4-7720-a10e-f8bc327eb9ef.webp",
      "image_media": {
        "alt_text": "A living room with a grey sofa, a coffee table, a TV stand, and large windows.",
        "public_id": "01a03e5c-9ce4-7720-a10e-f8bc327eb9ef",
        "storage_key": "property/6767906449167743/01a03e5c-9ce4-7720-a10e-f8bc327eb9ef.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Explore this beautifully furnished living room, complete with a plush sofa, modern entertainment center, and large windows that let in plenty of natural light.",
      "link": "false",
      "alt_text": "A living room with a grey sofa, a coffee table, a TV stand, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2cn5jl5d5kLDHY4Fc6InRrLT0G4wV4Wxk9dYcS8RJ1I/115/image.png"
    },
    {
      "id": "ec_f4858edd240a0e6fad22a0c9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-aca4-714e-ab8f-dddc28140372.webp",
      "image_media": {
        "alt_text": "Modern apartment building lounge area with large sectional sofa and coffee table.",
        "public_id": "01a03e5c-aca4-714e-ab8f-dddc28140372",
        "storage_key": "property/6767906449167743/01a03e5c-aca4-714e-ab8f-dddc28140372.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and unwind in the spacious and stylish lounge area of our apartment community. Featuring comfortable seating and a contemporary design.",
      "link": "false",
      "alt_text": "Modern apartment building lounge area with large sectional sofa and coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/aZjo44NaaKxiQJX2AkHBT6sRc3g7ppWKVy4zrcIeMxU/119/image.png"
    },
    {
      "id": "ec_6b050c288c4482f198d714b0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-a625-7716-b878-dfc2bcd5e55d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets and granite countertops, opening to a living area.",
        "public_id": "01a03e5c-a625-7716-b878-dfc2bcd5e55d",
        "storage_key": "property/6767906449167743/01a03e5c-a625-7716-b878-dfc2bcd5e55d.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience the perfect blend of style and functionality in this modern apartment kitchen, featuring sleek gray cabinetry and granite countertops, flowing seamlessly into the living space.",
      "link": "false",
      "alt_text": "Modern kitchen with gray cabinets and granite countertops, opening to a living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/BOPo7ziV1YZ8sTR4PVs0BBN6kqSIrUqi3RPjhrXd6bg/115/image.png"
    },
    {
      "id": "ec_e612b5bda14a4c7e41ba9b45",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-aa25-71c2-9133-0df4530b6461.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with cardio machines, free weights, and inspirational wall art.",
        "public_id": "01a03e5c-aa25-71c2-9133-0df4530b6461",
        "storage_key": "property/6767906449167743/01a03e5c-aa25-71c2-9133-0df4530b6461.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Our fully equipped fitness center offers a wide range of cardio machines, weight training equipment, and functional fitness gear to help you achieve your wellness goals.",
      "link": "false",
      "alt_text": "State-of-the-art fitness center with cardio machines, free weights, and inspirational wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/iGNQTKPyXRLI7L_AouDBArOkNGE2zXfz0l2zunywbl8/119/image.png"
    },
    {
      "id": "ec_cb5e5e640929c72a88020ccc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-bbf4-710a-a514-2796e3ba313b.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, bedside table, and artwork on the wall.",
        "public_id": "01a03e5c-bbf4-710a-a514-2796e3ba313b",
        "storage_key": "property/6767906449167743/01a03e5c-bbf4-710a-a514-2796e3ba313b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A stylish bedroom featuring a comfortable queen-size bed, a modern bedside table with a lamp, and decorative artwork, creating a relaxing ambiance.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, bedside table, and artwork on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/O1okC2_ABd0U3WWkLc9FuPlcvgIKgsOQiDIFsKukv6U/115/image.png"
    },
    {
      "id": "ec_2a054a3457fca8a9188289e6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-c110-75dd-8085-147fcdae81b8.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, dumbbells, and a television.",
        "public_id": "01a03e5c-c110-75dd-8085-147fcdae81b8",
        "storage_key": "property/6767906449167743/01a03e5c-c110-75dd-8085-147fcdae81b8.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center offers a variety of weight machines, free weights, and cardio equipment to help you stay in shape.",
      "link": "false",
      "alt_text": "Fitness center with weight machines, dumbbells, and a television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Mgg29gTeEkv2WzQUSEcJE40zS4s2OWgO_ZjkNgeTFr0/119/image.png"
    },
    {
      "id": "ec_b97e434b6d0e7cd4da9145a1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-bb54-768b-b353-d5164dc747f9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with gray vanity, granite countertop, and walk-in closet.",
        "public_id": "01a03e5c-bb54-768b-b353-d5164dc747f9",
        "storage_key": "property/6767906449167743/01a03e5c-bb54-768b-b353-d5164dc747f9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into luxury with this modern bathroom featuring a spacious vanity, granite countertops, and a convenient walk-in closet. Perfect for your daily routine.",
      "link": "false",
      "alt_text": "Modern bathroom with gray vanity, granite countertop, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/QP6HB7zNHYLuSQ16RUJtmX4fXzwgSHKwo1Aj3rMF-mg/114/image.png"
    },
    {
      "id": "ec_50c054a8b91df88e5bd014d6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-c54b-77fe-8ad3-011228167471.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a large TV, bar seating, and elegant decor.",
        "public_id": "01a03e5c-c54b-77fe-8ad3-011228167471",
        "storage_key": "property/6767906449167743/01a03e5c-c54b-77fe-8ad3-011228167471.webp",
        "width": 1912,
        "height": 1276
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish lounge, featuring a large screen TV and comfortable bar seating. Perfect for unwinding or entertaining.",
      "link": "false",
      "alt_text": "Modern lounge area with a large TV, bar seating, and elegant decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hK98j8c0urgcDNamvXjhuPQNRYGtWIuTPdm4rKK7Z-s/118/image.png"
    },
    {
      "id": "ec_b122fb2faa9d07c8ae30d529",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-c681-746d-99d3-115470c75176.webp",
      "image_media": {
        "alt_text": "A beautifully decorated bedroom with a queen-sized bed, plush pillows, and a green throw blanket.",
        "public_id": "01a03e5c-c681-746d-99d3-115470c75176",
        "storage_key": "property/6767906449167743/01a03e5c-c681-746d-99d3-115470c75176.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Relax in this inviting bedroom, featuring a comfortable queen-sized bed adorned with decorative pillows and a cozy green throw blanket. The room is elegantly styled with a unique headboard and warm accent lighting.",
      "link": "false",
      "alt_text": "A beautifully decorated bedroom with a queen-sized bed, plush pillows, and a green throw blanket.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/FDZXhEsqPBGwf8N_yqaGbUG7Gh-YOuZELt9p0DqJ9zI/114/image.png"
    },
    {
      "id": "ec_7b0db822cae785f6f94b8845",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-d50b-7267-bc18-355b4d880e05.webp",
      "image_media": {
        "alt_text": "Mail room with rows of mailboxes.",
        "public_id": "01a03e5c-d50b-7267-bc18-355b4d880e05",
        "storage_key": "property/6767906449167743/01a03e5c-d50b-7267-bc18-355b4d880e05.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Secure and convenient mail room for residents, featuring multiple rows of individual mailboxes.",
      "link": "false",
      "alt_text": "Mail room with rows of mailboxes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3O2kg8zLQQvJVY_I9cSoD_dxw8yjTJhiO5nQW1msPJI/119/image.png"
    },
    {
      "id": "ec_295df7bebfcb736412955896",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-de17-7006-b3a4-4173a940ba09.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with stacked towels.",
        "public_id": "01a03e5c-de17-7006-b3a4-4173a940ba09",
        "storage_key": "property/6767906449167743/01a03e5c-de17-7006-b3a4-4173a940ba09.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs. Stacked towels add a touch of cleanliness.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with stacked towels.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ldJ3RUZnu64vtciV94WxrUcgI-tje6PWHBF7uAOMDYY/114/image.png"
    },
    {
      "id": "ec_ec2bac00089367df7c513ca3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-e234-7414-b219-ae48fcdb06f8.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and surrounding park.",
        "public_id": "01a03e5c-e234-7414-b219-ae48fcdb06f8",
        "storage_key": "property/6767906449167743/01a03e5c-e234-7414-b219-ae48fcdb06f8.webp",
        "width": 1673,
        "height": 1114
      },
      "title": "Community",
      "description": "Experience modern living in these apartment buildings, featuring a sparkling pool and lush green spaces for relaxation and recreation.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with a pool and surrounding park.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/unc3iHS1hvkKzyLd4Qvuswmn3tRm4CEGu9DlhYkg0aY/118/image.png"
    },
    {
      "id": "ec_e0f8673d51790a0d70e5a308",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-e042-71df-b83e-77cc9218fa2d.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with brick facade and balconies.",
        "public_id": "01a03e5c-e042-71df-b83e-77cc9218fa2d",
        "storage_key": "property/6767906449167743/01a03e5c-e042-71df-b83e-77cc9218fa2d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Modern apartment building exterior with balconies and landscaped grounds, showcasing the community's attractive architecture.",
      "link": "false",
      "alt_text": "Exterior view of a modern apartment building with brick facade and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/XD0gaXf_u226n-BLW8qoUV4UkuY52VNTRwkmG8jweGQ/114/image.jpg"
    },
    {
      "id": "ec_2716313ba5ada9d552e3a263",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-e76b-75bf-a9b5-8bbb62f22d5c.webp",
      "image_media": {
        "alt_text": "Lobby with coffee bar, seating area, and communal tables.",
        "public_id": "01a03e5c-e76b-75bf-a9b5-8bbb62f22d5c",
        "storage_key": "property/6767906449167743/01a03e5c-e76b-75bf-a9b5-8bbb62f22d5c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax in our comfortable lobby area, complete with a coffee bar and ample seating for work or socializing.",
      "link": "false",
      "alt_text": "Lobby with coffee bar, seating area, and communal tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/xVYy9kh1DxViLh577z8obucCCFVeNJW4JqrfnGyp7yA/102/image.jpg"
    },
    {
      "id": "ec_23786cc911efa3dd3069fd9e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-ec5e-747e-8cac-d203953436a4.webp",
      "image_media": {
        "alt_text": "Gym with boxing bag, rowing machine, weights, and cardio equipment.",
        "public_id": "01a03e5c-ec5e-747e-8cac-d203953436a4",
        "storage_key": "property/6767906449167743/01a03e5c-ec5e-747e-8cac-d203953436a4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center offers a boxing bag, free weights, cardio machines, and more for your workout needs.",
      "link": "false",
      "alt_text": "Gym with boxing bag, rowing machine, weights, and cardio equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/WyPja3MJ81hEYvRjUXtHFPKjJpIZZMGK8oMI9_zjj00/117/image.jpg"
    },
    {
      "id": "ec_224e8878abdfcc116f5869de",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-f7c6-7278-80b4-19c927b3c521.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, plyo boxes, and motivational wall art.",
        "public_id": "01a03e5c-f7c6-7278-80b4-19c927b3c521",
        "storage_key": "property/6767906449167743/01a03e5c-f7c6-7278-80b4-19c927b3c521.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment and strength training essentials.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, plyo boxes, and motivational wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3bpL71TLRKIXsSRoTvrrIa6kJzuDn3CwTZpW53ZboHI/102/image.jpg"
    },
    {
      "id": "ec_fcd828c849da8cff0be980d9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-045e-72e9-a032-d104ceed5337.webp",
      "image_media": {
        "alt_text": "Fitness center gym with treadmills, weight machines, and free weights.",
        "public_id": "01a03e5d-045e-72e9-a032-d104ceed5337",
        "storage_key": "property/6767906449167743/01a03e5d-045e-72e9-a032-d104ceed5337.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with cardio machines, weight training equipment, and free weights for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center gym with treadmills, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/LwYLd_pCVddQYUUwncbjvyfKoOMvX66hHB89ObYPmb8/117/image.jpg"
    },
    {
      "id": "ec_8525e3ee86f8b6ad86b9078e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-144a-7262-8639-c3a9c56f83f7.webp",
      "image_media": {
        "alt_text": "A small convenience store with snacks and drinks, including refrigerators and shelves stocked with products, and a self-checkout kiosk.",
        "public_id": "01a03e5d-144a-7262-8639-c3a9c56f83f7",
        "storage_key": "property/6767906449167743/01a03e5d-144a-7262-8639-c3a9c56f83f7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Grab your favorite snacks and drinks from our convenient on-site store, stocked with a variety of options to satisfy your cravings.",
      "link": "false",
      "alt_text": "A small convenience store with snacks and drinks, including refrigerators and shelves stocked with products, and a self-checkout kiosk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/dg4DSeQvQakuYfHiJTNyYTisO8cnj8qRmh2tjOL8fbk/104/image.jpg"
    },
    {
      "id": "ec_dfe52fc988247ecb22f0d1a5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-0df7-7578-a1db-002b17dfe4fa.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a03e5d-0df7-7578-a1db-002b17dfe4fa",
        "storage_key": "property/6767906449167743/01a03e5d-0df7-7578-a1db-002b17dfe4fa.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the pool. This resort-style oasis features comfortable lounge chairs, shaded areas, and a luxurious pool perfect for unwinding.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rIFLmN4l2hJhglttnGuRX2QD7pRem8zAU7yUGjQr034/117/image.jpg"
    },
    {
      "id": "ec_5c4b3ee4a9a7522ef539e95b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-2828-73ed-802a-39d59d0f279a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a03e5d-2828-73ed-802a-39d59d0f279a",
        "storage_key": "property/6767906449167743/01a03e5d-2828-73ed-802a-39d59d0f279a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and modern kitchen featuring sleek gray cabinetry, beautiful granite countertops, and top-of-the-line stainless steel appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with gray cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/gheljpA0ZQ5wP53R6nMF2qiztD-OFNi-ZTvD2s-DWEc/104/image.jpg"
    },
    {
      "id": "ec_d95ff6bdc18a387a1786dcd1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-0e4d-7449-aa42-676b91702442.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and a breakfast bar with stools.",
        "public_id": "01a03e5d-0e4d-7449-aa42-676b91702442",
        "storage_key": "property/6767906449167743/01a03e5d-0e4d-7449-aa42-676b91702442.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek gray cabinetry, elegant granite countertops, and a full suite of stainless steel appliances. A stylish breakfast bar with comfortable stools is perfect for casual dining or entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and a breakfast bar with stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/UdJnWdYFjSXfM_2ZZONKkZXzwWD_ipJrSMxNgMt7QzQ/118/image.jpg"
    },
    {
      "id": "ec_d53e66e5fce23424700618f5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-1ae9-700d-8293-644c2a0042a1.webp",
      "image_media": {
        "alt_text": "Cozy living room with a gray sofa, decorative pillows, a coffee table, and large windows.",
        "public_id": "01a03e5d-1ae9-700d-8293-644c2a0042a1",
        "storage_key": "property/6767906449167743/01a03e5d-1ae9-700d-8293-644c2a0042a1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living room, featuring a comfortable gray sofa, elegant decor, and ample natural light from the large windows.",
      "link": "false",
      "alt_text": "Cozy living room with a gray sofa, decorative pillows, a coffee table, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4FbkfGvcHc_NA9IkITfCjzdssbNM-RF5JTxsfa1ocGc/104/image.jpg"
    },
    {
      "id": "ec_fe17669c886165af5d8d206a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-24fa-734a-87df-a197e22cc66a.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, plush green bedding, and a large window with white curtains.",
        "public_id": "01a03e5d-24fa-734a-87df-a197e22cc66a",
        "storage_key": "property/6767906449167743/01a03e5d-24fa-734a-87df-a197e22cc66a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a king-size bed and elegant decor.",
      "link": "false",
      "alt_text": "Stylish bedroom with a king-size bed, plush green bedding, and a large window with white curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vG--bYbJSbAZR2Ge89QcR-vITfixiEEQ2gYIE2LLuV0/118/image.jpg"
    },
    {
      "id": "ec_e4941d707dacf9997818929d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-2a91-720e-bb98-0060615b6244.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a gray vanity, granite countertop, and a walk-in shower.",
        "public_id": "01a03e5d-2a91-720e-bb98-0060615b6244",
        "storage_key": "property/6767906449167743/01a03e5d-2a91-720e-bb98-0060615b6244.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience luxury in this modern bathroom featuring a spacious vanity, granite countertops, and a sleek walk-in shower, perfect for unwinding.",
      "link": "false",
      "alt_text": "Modern bathroom with a gray vanity, granite countertop, and a walk-in shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/y6jr8H81xOtAxtIQsDVBLZCY5KQ_e6dgD-YXf-SZP_o/104/image.jpg"
    },
    {
      "id": "ec_6e3006835454321e7468c3af",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-5606-77af-8eec-d56eebdf09d3.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island seating and stainless steel appliances.",
        "public_id": "01a03e5d-5606-77af-8eec-d56eebdf09d3",
        "storage_key": "property/6767906449167743/01a03e5d-5606-77af-8eec-d56eebdf09d3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish apartment kitchen, featuring a large island, sleek grey cabinetry, and stainless steel appliances. The adjacent living area offers a comfortable space to relax.",
      "link": "false",
      "alt_text": "Modern kitchen and living area with island seating and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Gr_ZjN_jwSDv-rGnxHTUTPNArLXw5naNfpNrSnqoWyw/116/image.jpg"
    },
    {
      "id": "ec_27ae3f538f2392aafcd803c0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-39de-7324-8184-1dc526a80823.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sofa, black coffee table, geometric rug, and a view into a bedroom.",
        "public_id": "01a03e5d-39de-7324-8184-1dc526a80823",
        "storage_key": "property/6767906449167743/01a03e5d-39de-7324-8184-1dc526a80823.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into the stylish living area, featuring a comfortable gray sofa, a modern coffee table, and a striking geometric rug. Enjoy the view into the adjacent bedroom, creating an open and inviting atmosphere.",
      "link": "false",
      "alt_text": "Modern living room with a gray sofa, black coffee table, geometric rug, and a view into a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/GOYSnTIvG4M0ZcMIIL7YK_iKoZR-1BlWNmUMxyictoA/104/image.jpg"
    },
    {
      "id": "ec_716c6575d96e2bb1940a920e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-3e90-711e-8a2a-54dac6acd2e1.webp",
      "image_media": {
        "alt_text": "A stylish bedroom featuring a king-sized bed with a geometric patterned duvet and green and black pillows, set against a modern accent wall.",
        "public_id": "01a03e5d-3e90-711e-8a2a-54dac6acd2e1",
        "storage_key": "property/6767906449167743/01a03e5d-3e90-711e-8a2a-54dac6acd2e1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this beautifully appointed bedroom, designed with contemporary flair and sophisticated finishes. The king-sized bed and modern decor create a serene retreat.",
      "link": "false",
      "alt_text": "A stylish bedroom featuring a king-sized bed with a geometric patterned duvet and green and black pillows, set against a modern accent wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/UhNE-EDQEw0Nqfj12Fr1TCaMGyl9GpQcPTENZxpHlN4/119/image.jpg"
    },
    {
      "id": "ec_b9b85ac37e9e2b4ed545c42c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-3d64-714c-93d3-2aab105ba180.webp",
      "image_media": {
        "alt_text": "Modern bathroom with gray vanity, granite countertop, dual sinks, large mirror, and walk-in closet.",
        "public_id": "01a03e5d-3d64-714c-93d3-2aab105ba180",
        "storage_key": "property/6767906449167743/01a03e5d-3d64-714c-93d3-2aab105ba180.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience luxury in this spacious bathroom featuring a double vanity, ample counter space, and a large walk-in closet, perfect for organizing your essentials.",
      "link": "false",
      "alt_text": "Modern bathroom with gray vanity, granite countertop, dual sinks, large mirror, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/zWqcYg9sOBogC_Nhl3BlF2qJE5S9Z81Ort8wgZLfy8w/104/image.jpg"
    },
    {
      "id": "ec_8daed5ae57725a36468f70df",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-4832-778c-99e0-5a978d5985b9.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, a desk, and a chair.",
        "public_id": "01a03e5d-4832-778c-99e0-5a978d5985b9",
        "storage_key": "property/6767906449167743/01a03e5d-4832-778c-99e0-5a978d5985b9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and stylish bedroom featuring a comfortable queen-size bed, a functional desk area, and a plush accent chair, perfect for relaxation and productivity.",
      "link": "false",
      "alt_text": "Modern bedroom with a queen-size bed, a desk, and a chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4DbNP31xyB-t6nCImePkqsCugF8Tgh8EaTNkNKg9QZk/119/image.jpg"
    },
    {
      "id": "ec_7a434fc0d0a1640dc549abe0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-5778-70ab-813d-0996d3ff122a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with gray vanity, granite countertop, and large mirror. Includes a walk-in closet and a bathtub.",
        "public_id": "01a03e5d-5778-70ab-813d-0996d3ff122a",
        "storage_key": "property/6767906449167743/01a03e5d-5778-70ab-813d-0996d3ff122a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with a granite countertop, a large framed mirror, and ample storage. Enjoy the convenience of a walk-in closet and a relaxing bathtub.",
      "link": "false",
      "alt_text": "Modern bathroom with gray vanity, granite countertop, and large mirror. Includes a walk-in closet and a bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/0CFFh9U_WYonGQ5TLtwvm3FGEMgz8Eqx4NZe2ZbUbWI/104/image.jpg"
    },
    {
      "id": "ec_0bd99f382489d290f9cd3b85",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-5e28-72d1-bb9f-938f0338f430.webp",
      "image_media": {
        "alt_text": "Spin bikes and exercise equipment in a well-lit fitness center with large windows overlooking an outdoor area.",
        "public_id": "01a03e5d-5e28-72d1-bb9f-938f0338f430",
        "storage_key": "property/6767906449167743/01a03e5d-5e28-72d1-bb9f-938f0338f430.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment and free weights. Enjoy your workout with a view of the community grounds.",
      "link": "false",
      "alt_text": "Spin bikes and exercise equipment in a well-lit fitness center with large windows overlooking an outdoor area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/-SqRrRsGEtwFUuNsFMo9JU7PNgw7TuL_A3JQLFTXdds/118/image.jpg"
    },
    {
      "id": "ec_d0dd1cec402bbc3a205bf11a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-6055-7251-97ab-64771c43c335.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with bar seating and a picnic table near the pool.",
        "public_id": "01a03e5d-6055-7251-97ab-64771c43c335",
        "storage_key": "property/6767906449167743/01a03e5d-6055-7251-97ab-64771c43c335.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our built-in grills, bar seating, and picnic tables. Perfect for entertaining guests or relaxing by the pool.",
      "link": "false",
      "alt_text": "Outdoor grilling station with bar seating and a picnic table near the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/D54cNm0KZ8q_d0dVjcdZrCPOChqjTAPucIA1vT4ylyQ/119/image.jpg"
    },
    {
      "id": "ec_bf6264f890b08b74d30ecaf9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-5c11-757b-8b3d-2fb5b9e2308e.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with surrounding landscaping and distant cityscape.",
        "public_id": "01a03e5d-5c11-757b-8b3d-2fb5b9e2308e",
        "storage_key": "property/6767906449167743/01a03e5d-5c11-757b-8b3d-2fb5b9e2308e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Experience modern living in this expansive community, featuring stunning architecture and lush green spaces. Enjoy easy access to nearby amenities and scenic views.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with surrounding landscaping and distant cityscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/c3x5_KuJ4Ro_AGa7LOYxLtCDhtlzoxsn1msgo_8O6_0/102/image.jpg"
    },
    {
      "id": "ec_fbf98468c768c737281f577b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-78a1-7690-94b6-db2a0b7fc97c.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and large windows.",
        "public_id": "01a03e5d-78a1-7690-94b6-db2a0b7fc97c",
        "storage_key": "property/6767906449167743/01a03e5d-78a1-7690-94b6-db2a0b7fc97c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of a contemporary apartment building, showcasing its brick facade, private balconies, and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with balconies and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_fBZYyhF6a1fC8ZDSIo71ClCWiyDipIO5m_lb99VZ_Y/102/image.jpg"
    },
    {
      "id": "ec_5677572d390f739a79fa212a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-789a-721c-a48f-3b2effe7b1f9.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area in an apartment with stylish furniture and stainless steel appliances.",
        "public_id": "01a03e5d-789a-721c-a48f-3b2effe7b1f9",
        "storage_key": "property/6767906449167743/01a03e5d-789a-721c-a48f-3b2effe7b1f9.webp",
        "width": 2048,
        "height": 341
      },
      "title": "Apartment",
      "description": "Step into a beautifully designed living space featuring a contemporary kitchen with granite countertops and sleek cabinetry, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern living room and kitchen area in an apartment with stylish furniture and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/xWoG8DuC7OAqQXZ1dA-cJXphYbO9HazuRi1WeQqKmTw/102/image.jpg"
    },
    {
      "id": "ec_7e2e31bdbec49bb684f7d264",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-8276-738e-b0f0-5cf1d0511053.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings under construction.",
        "public_id": "01a03e5d-8276-738e-b0f0-5cf1d0511053",
        "storage_key": "property/6767906449167743/01a03e5d-8276-738e-b0f0-5cf1d0511053.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Aerial view of apartment buildings currently under construction, showcasing the exterior framing and surrounding grounds.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings under construction.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/R4X74DNojD4_EsgVzAI7vP3SJ_amGWv8rtVBuvVa8HY/118/image.jpg"
    },
    {
      "id": "ec_c9ce895caa29763532b2acc6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-84d4-717e-bf42-4edafa6f4d08.webp",
      "image_media": {
        "alt_text": "Construction of new apartment buildings with green exterior sheathing and wooden roofs.",
        "public_id": "01a03e5d-84d4-717e-bf42-4edafa6f4d08",
        "storage_key": "property/6767906449167743/01a03e5d-84d4-717e-bf42-4edafa6f4d08.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Aerial view of an apartment complex under construction, showcasing multiple buildings with visible framing and green sheathing. Surrounding landscape includes trees and other finished buildings.",
      "link": "false",
      "alt_text": "Construction of new apartment buildings with green exterior sheathing and wooden roofs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HkClyFjvkhwT0S5YdKz3P2-4ueCIAIbis0_5g3YD3Ow/113/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_83d61956f1795da7121ca9f5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Ernesto's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1518 Northwest Hwy, Garland, TX 75041, USA",
      "poi_short_description": "Traditional Mexican fare served in a bright venue with kitschy decor & a cantina-style bar.",
      "poi_long_description": "Traditional Mexican fare served in a bright venue with kitschy decor & a cantina-style bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-e8d6-72ca-8bd0-afa15e7e0598.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-e8d6-72ca-8bd0-afa15e7e0598",
        "storage_key": "property/6767906449167743/01a03e5b-e8d6-72ca-8bd0-afa15e7e0598.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://orderernestosmexican.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9396904652191177134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ernestos-mexican-restaurant",
      "poi_latitude": "32.8634692",
      "poi_longitude": "-96.650271",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 972-681-8112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ24u1SOnToYRrhkShv6CaII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_6e238dc0b4580f5609c048d7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Kahawa 4110",
      "poi_type": "Restaurants",
      "poi_address": "3003 N President George Bush Hwy #600, Garland, TX 75040, USA",
      "poi_short_description": "Relaxed coffee shop featuring a honey-sweetened espresso latte, plus croissants and avocado toast.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-db88-7449-8752-6e350dabeaf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-db88-7449-8752-6e350dabeaf2",
        "storage_key": "property/6767906449167743/01a03e5b-db88-7449-8752-6e350dabeaf2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kahawa4110.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9199871739437262217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kahawa-4110",
      "poi_latitude": "32.9459874",
      "poi_longitude": "-96.6113742",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 945-267-5255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-a612-72cf-ba0c-5ba427b81894.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a612-72cf-ba0c-5ba427b81894",
        "storage_key": "property/6767906449167743/01a03e5c-a612-72cf-ba0c-5ba427b81894.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJyUldHQAdTIYRiSVQoJqCrH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_a02952af6d9d6b065f02b60e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Lazy Dog Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "5180 N President George Bush Hwy, Garland, TX 75040, USA",
      "poi_short_description": "Relaxed, lodge-chic chain serving global comfort fare, including stir-fries, pot roast & pastas.",
      "poi_long_description": "Relaxed, lodge-chic chain serving global comfort fare, including stir-fries, pot roast & pastas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-df75-722a-bee7-f3cfdb7787a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-df75-722a-bee7-f3cfdb7787a1",
        "storage_key": "property/6767906449167743/01a03e5b-df75-722a-bee7-f3cfdb7787a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lazydogrestaurants.com/pages/garland-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9999715939121403096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lazy-dog-restaurant--bar",
      "poi_latitude": "32.9649559",
      "poi_longitude": "-96.6387518",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 945-207-7552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4awlDwAdTIYR2JQkdqogxoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_aa9324aade90f70f56f25a37",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4840 North George Bush Hwy, Garland, TX 75040, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-d8ac-74b9-866b-e51acb5923f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-d8ac-74b9-866b-e51acb5923f6",
        "storage_key": "property/6767906449167743/01a03e5b-d8ac-74b9-866b-e51acb5923f6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.olivegarden.com/locations/tx/garland/garland-firewheel/1673?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:garland-tx-1673_pl:locurl_rd:1526",
      "poi_directions_map_url": "https://maps.google.com/?cid=17893402765058201159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "32.961335",
      "poi_longitude": "-96.634217",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-530-8102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWi_HrQdTIYRR1ZJ8gIjUvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_881e0203e5e07dce3b2cf5d9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "5012 N President George Bush Hwy, Garland, TX 75040, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e59-568b-700e-bb47-b9fc56c7df48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-568b-700e-bb47-b9fc56c7df48",
        "storage_key": "property/6767906449167743/01a03e59-568b-700e-bb47-b9fc56c7df48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/garland?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=16738526719177846910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.96322019999999",
      "poi_longitude": "-96.6367052",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-495-0417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk7MjJkQcTIYRfvD6110xS-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_15ed7a962a435a4018e8fd55",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "5031 N Garland Ave, Garland, TX 75044, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-d3b2-7450-8c42-52d09b1bfd02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-d3b2-7450-8c42-52d09b1bfd02",
        "storage_key": "property/6767906449167743/01a03e5b-d3b2-7450-8c42-52d09b1bfd02.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/tx/garland/garland-633",
      "poi_directions_map_url": "https://maps.google.com/?cid=8107296757806972144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "32.9625047",
      "poi_longitude": "-96.6469003",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-530-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfyR9azkcTIYR8LzCaXLngnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4b49e8bf5e9dcae0f2dcba8f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "150 Town Center Blvd, Garland, TX 75040, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-f0fd-77f0-bb05-3cdbd3f4c62c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f0fd-77f0-bb05-3cdbd3f4c62c",
        "storage_key": "property/6767906449167743/01a03e5b-f0fd-77f0-bb05-3cdbd3f4c62c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/269",
      "poi_directions_map_url": "https://maps.google.com/?cid=3150549061892783269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "32.9540884",
      "poi_longitude": "-96.6174557",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVza6zv4cTIYRpTyP8a3_uCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_72b68185d2ae23d245c116e8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Ferah Tex-Med Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "690 Beebalm Ln, Garland, TX 75040, USA",
      "poi_short_description": "Friendly spot for Texas spin on Mediterranean favorites, including gyro quesadillas & falafel tacos.",
      "poi_long_description": "Friendly spot for Texas spin on Mediterranean favorites, including gyro quesadillas & falafel tacos.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ9zkyryMdTIYRjAGt57r8gwg/photos/AVoNoXT_rFl_Fh4LJRZYymcA52HbzfbQanMgDC2RqJAmrsj_M475e1TPDww69kEgA9ujb4D6_nuAc-ApedDUqnFqKlH5Eci0x0UezlmIGR5Z--GbpcDYyUxk9je2uGB7Bn5LNnwkxL_O2zOM2d4M2K60a1ht_8IYn1uBGL_esJAXLhDJ-5wBtH487o35jLXxwJFUEP759Z5BQ6QlYAZ2G_VEgT0hDJk1oGk750679PqTU-g16UEnJH88d6JAgLWbaj_3ZhZ4O1pPzmiP_FyeFalkbjX7qd_55hqBaTfcqpNywKn0-25NzY5mzXAEvGBr_2k_8QAVeXqwcRFGDJvAvKL2_TKkj-b0YpR_TZcwek9UmsP6juxEXVtdF3PZeZNjdS_BIxHqFCRQOD4XErRUMfqa8Gawfb3_DzEsSMvoGFlKfxL2QFo/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3024&maxHeightPx=3025",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ferahtexmed.com/garland",
      "poi_directions_map_url": "https://maps.google.com/?cid=613611853933511052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ferah-tex-med-kitchen",
      "poi_latitude": "32.954053",
      "poi_longitude": "-96.6108406",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-256-8971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zkyryMdTIYRjAGt57r8gwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_451ae072dbf4272443706943",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Gloria's Latin Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "360 Coneflower Dr, Garland, TX 75040, USA",
      "poi_short_description": "Family-friendly chain featuring Salvadoran & Tex-Mex favorites, plus mojitos & margaritas.",
      "poi_long_description": "Family-friendly chain featuring Salvadoran & Tex-Mex favorites, plus mojitos & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-d3ab-70ee-8d2d-dd4543511f23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-d3ab-70ee-8d2d-dd4543511f23",
        "storage_key": "property/6767906449167743/01a03e5b-d3ab-70ee-8d2d-dd4543511f23.webp",
        "width": 648,
        "height": 432
      },
      "poi_business_url": "https://gloriascuisine.com/locations/garland.html?utm_source=google&utm_medium=Yext&y_source=1_MjA1ODAzNTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3871909501019319829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glorias-latin-cuisine",
      "poi_latitude": "32.95193709999999",
      "poi_longitude": "-96.6126451",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-526-5290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2iT-_wcTIYRFW63Si3JuzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_e241699262b1a81fa660cb6b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Herb & Ember",
      "poi_type": "Restaurants",
      "poi_address": "365 Coneflower Dr, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-db75-744a-b0aa-91336e7f5210.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-db75-744a-b0aa-91336e7f5210",
        "storage_key": "property/6767906449167743/01a03e5b-db75-744a-b0aa-91336e7f5210.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "http://www.theherbandember.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7729122119354176246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "herb--ember",
      "poi_latitude": "32.9521868",
      "poi_longitude": "-96.6130276",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-256-8991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_4FjPD4dTIYR9lK47Z1bQ2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_7212c4e03c5901d10de15830",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Laughing Crab Cajun Seafood",
      "poi_type": "Restaurants",
      "poi_address": "340 Coneflower Dr, Garland, TX 75040, USA",
      "poi_short_description": "Down-to-earth eatery dispensing all-you-can-eat seafood dishes like snow crab.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-e655-760c-ad88-4dd4795de8bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-e655-760c-ad88-4dd4795de8bb",
        "storage_key": "property/6767906449167743/01a03e5b-e655-760c-ad88-4dd4795de8bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.laughingcrabgarlandtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11680078159820559153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "laughing-crab-cajun-seafood",
      "poi_latitude": "32.9517663",
      "poi_longitude": "-96.6126937",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-496-6788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bu2SPgdTIYRMRPn4DP5F6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_de85b6d86f976fa9bacf82af",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Los Corrales Potosinos",
      "poi_type": "Restaurants",
      "poi_address": "1449 S Jupiter Rd, Garland, TX 75042, USA",
      "poi_short_description": "Casual restaurant offering familiar Latin-American eats like fajitas and enchiladas, tacos and burritos alongside pancakes for breakfast and lunch.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-ed6e-7259-8e16-60cc9b1dc589.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-ed6e-7259-8e16-60cc9b1dc589",
        "storage_key": "property/6767906449167743/01a03e5b-ed6e-7259-8e16-60cc9b1dc589.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loscorralesmxcuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1398368817307329066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-corrales-potosinos",
      "poi_latitude": "32.899054",
      "poi_longitude": "-96.683456",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-487-8222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6c1XaCgToYRKiKWzAcBaBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_9d63f6569cbe12b08690523f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Babe's Chicken Dinner House",
      "poi_type": "Restaurants",
      "poi_address": "1456 Belt Line Rd #171, Garland, TX 75044, USA",
      "poi_short_description": "Relaxed local chain serving fried chicken & homestyle American sides in a rustic setting.",
      "poi_long_description": "Relaxed local chain serving fried chicken & homestyle American sides in a rustic setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-efbe-764d-a05d-393a78cd1807.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-efbe-764d-a05d-393a78cd1807",
        "storage_key": "property/6767906449167743/01a03e5b-efbe-764d-a05d-393a78cd1807.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://babeschicken.com/?y_source=1_MjAyMjkwMzQ0MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7168559849874128064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "babes-chicken-dinner-house",
      "poi_latitude": "32.9435922",
      "poi_longitude": "-96.6485449",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-496-1041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4fRd9cwdTIYRwPzf6jPXe2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "ec_20e209f055c8fdffaf89c903",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Main Street Cafe",
      "poi_type": "Restaurants",
      "poi_address": "627 Main St, Garland, TX 75040, USA",
      "poi_short_description": "Friendly locale serving hearty fried dishes and home-cooked meals, plus burgers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-f5fa-70ae-9b1a-0bc9057477ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f5fa-70ae-9b1a-0bc9057477ac",
        "storage_key": "property/6767906449167743/01a03e5b-f5fa-70ae-9b1a-0bc9057477ac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/mainstreet627/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15348365013715832947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-cafe",
      "poi_latitude": "32.9128633",
      "poi_longitude": "-96.6388129",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-703-0210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQnHfGodTIYRc9CQLalYANU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_0c7a0bbfe968c738ff75ca2a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Tom Yum Thai",
      "poi_type": "Restaurants",
      "poi_address": "3313 Belt Line Rd, Garland, TX 75044, USA",
      "poi_short_description": "The Southeast Asian favorites are available at 5 spice levels at this sleek, modern cafe.",
      "poi_long_description": "The Southeast Asian favorites are available at 5 spice levels at this sleek, modern cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-fca8-76c9-81db-7062d65f6983.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-fca8-76c9-81db-7062d65f6983",
        "storage_key": "property/6767906449167743/01a03e5b-fca8-76c9-81db-7062d65f6983.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mytomyumthai.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17301771661397503190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-yum-thai",
      "poi_latitude": "32.9456523",
      "poi_longitude": "-96.6786395",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-703-0391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b1-719c-a625-ce807d1f6ce5",
        "storage_key": "property/6767906449167743/01a03e5a-81b1-719c-a625-ce807d1f6ce5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3-F5DmIeTIYR1qyERqg9HPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_962ca01a905a1f62fb9f06df",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "6850 N Shiloh Rd, Garland, TX 75044, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5b-f342-76c8-8f26-a5162ce0539d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f342-76c8-8f26-a5162ce0539d",
        "storage_key": "property/6767906449167743/01a03e5b-f342-76c8-8f26-a5162ce0539d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/garland/shiloh-springs/035/00557?cid=loc_03500557_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=10479510411900659266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.9772556",
      "poi_longitude": "-96.6638625",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-496-4603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81bc-74a8-8e47-c420eb30b4e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81bc-74a8-8e47-c420eb30b4e4",
        "storage_key": "property/6767906449167743/01a03e5a-81bc-74a8-8e47-c420eb30b4e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_SFcn6ceTIYRQqZYYTKzbpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_ab4ee2ae25c518875f95bbe3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Daiso - Japanese Household Goods",
      "poi_type": "Shopping & Retail",
      "poi_address": "6850 N Shiloh Rd P, Garland, TX 75044, USA",
      "poi_short_description": "Japanese variety-store chain featuring Japanese beauty products, housewares & snacks.",
      "poi_long_description": "Japanese variety-store chain featuring Japanese beauty products, housewares & snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-0421-7349-9543-377a734f61d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-0421-7349-9543-377a734f61d5",
        "storage_key": "property/6767906449167743/01a03e5c-0421-7349-9543-377a734f61d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://daisous.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=627506183418767891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daiso---japanese-household-goods",
      "poi_latitude": "32.9776998",
      "poi_longitude": "-96.6641026",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 945-200-5920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8172-75a1-9af2-44e775a21aea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8172-75a1-9af2-44e775a21aea",
        "storage_key": "property/6767906449167743/01a03e5a-8172-75a1-9af2-44e775a21aea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzxL_bX8fTIYRE2oJlYxZtQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "ec_c98d3aa25299f272ee95b480",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1372 Belt Line Rd, Garland, TX 75040, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-03ba-72b6-a9df-b3385e2aba09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-03ba-72b6-a9df-b3385e2aba09",
        "storage_key": "property/6767906449167743/01a03e5c-03ba-72b6-a9df-b3385e2aba09.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/garland-tx-pharmacies/1372-beltline-rd-garland-tx-75040/storeid=7481?WT.mc_id=LS_GOOGLE_FS_7481",
      "poi_directions_map_url": "https://maps.google.com/?cid=1348556235230498748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "32.9445355",
      "poi_longitude": "-96.6469838",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-495-1933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUfecMsdTIYRvE-NQMAItxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_cc98f5579c584b988319abcd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "5950 Broadway Blvd Walgreens, Garland, TX 75043, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-0d27-7119-8404-4c4f193991d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-0d27-7119-8404-4c4f193991d5",
        "storage_key": "property/6767906449167743/01a03e5c-0d27-7119-8404-4c4f193991d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-5950+broadway+blvd-garland-tx-75043/id=7586",
      "poi_directions_map_url": "https://maps.google.com/?cid=16615169747478501950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.8435406",
      "poi_longitude": "-96.5947712",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 972-303-3191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-RFpsz6mToYRPtpFudrwlOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_fb1d920daab5773fd17274aa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3959 Broadway Blvd, Garland, TX 75043, USA",
      "poi_short_description": "Grocery chain featuring a bakery, deli and pharmacy, plus electronics and toys.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-0298-7510-9637-ad3f55a0c95a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-0298-7510-9637-ad3f55a0c95a",
        "storage_key": "property/6767906449167743/01a03e5c-0298-7510-9637-ad3f55a0c95a.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://www.walmart.com/store/2975-garland-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5210289235940821206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "32.8646341",
      "poi_longitude": "-96.6069562",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 972-926-6215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81bc-74a8-8e47-c420eb30b4e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81bc-74a8-8e47-c420eb30b4e4",
        "storage_key": "property/6767906449167743/01a03e5a-81bc-74a8-8e47-c420eb30b4e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM1Fu2bOnToYR1khLbXSqTkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_bf0337a511c5c685d7fbf4f5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Tom Thumb",
      "poi_type": "Shopping & Retail",
      "poi_address": "2645 Arapaho Rd, Garland, TX 75044, USA",
      "poi_short_description": "Neighborhood, chain supermarket that's clean and well-organized and sells organic foods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-13cc-703f-8f3d-6836f3967885.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-13cc-703f-8f3d-6836f3967885",
        "storage_key": "property/6767906449167743/01a03e5c-13cc-703f-8f3d-6836f3967885.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.tomthumb.com/tx/garland/2645-arapaho-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16272165596521561450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb",
      "poi_latitude": "32.9608229",
      "poi_longitude": "-96.6670173",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-495-9807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81bc-74a8-8e47-c420eb30b4e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81bc-74a8-8e47-c420eb30b4e4",
        "storage_key": "property/6767906449167743/01a03e5a-81bc-74a8-8e47-c420eb30b4e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeJWqZ0eTIYRav3_emVY0uE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_3ace92220b77f1c27ac7fb22",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Firewheel Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "245 Cedar Sage Dr, Garland, TX 75040, USA",
      "poi_short_description": "Open-air shopping venue offering brand-name department stores & boutiques, eateries & a cinema.",
      "poi_long_description": "Open-air shopping venue offering brand-name department stores & boutiques, eateries & a cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e59-3cc0-721b-8149-e39c33f5324d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-3cc0-721b-8149-e39c33f5324d",
        "storage_key": "property/6767906449167743/01a03e59-3cc0-721b-8149-e39c33f5324d.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "https://www.simon.com/mall/firewheel-town-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11573802943106674088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firewheel-town-center",
      "poi_latitude": "32.9538707",
      "poi_longitude": "-96.6126318",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-675-1041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8172-75a1-9af2-44e775a21aea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8172-75a1-9af2-44e775a21aea",
        "storage_key": "property/6767906449167743/01a03e5a-8172-75a1-9af2-44e775a21aea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfQHcjvwcTIYRqG0-xHRonqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_97f1ee69a53e4be9ed4d5441",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "5301 N Garland Ave, Garland, TX 75040, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-1ea2-707a-8914-7de6fea6191b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1ea2-707a-8914-7de6fea6191b",
        "storage_key": "property/6767906449167743/01a03e5c-1ea2-707a-8914-7de6fea6191b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/garland-east/1489",
      "poi_directions_map_url": "https://maps.google.com/?cid=11781631119895688979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.9654216",
      "poi_longitude": "-96.6465667",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-535-0252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8172-75a1-9af2-44e775a21aea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8172-75a1-9af2-44e775a21aea",
        "storage_key": "property/6767906449167743/01a03e5a-8172-75a1-9af2-44e775a21aea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ59_kzTgcTIYRE_cR8BTDgKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_4b1e16d08cc0d97a5bc44a20",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "5150 N Garland Ave, Garland, TX 75040, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-0de4-71cb-adeb-1d6a271bd34f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-0de4-71cb-adeb-1d6a271bd34f",
        "storage_key": "property/6767906449167743/01a03e5c-0de4-71cb-adeb-1d6a271bd34f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/4783-garland-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=8528854266588463098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "32.9609715",
      "poi_longitude": "-96.6444502",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-496-3956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8172-75a1-9af2-44e775a21aea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8172-75a1-9af2-44e775a21aea",
        "storage_key": "property/6767906449167743/01a03e5a-8172-75a1-9af2-44e775a21aea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtRwOFDkcTIYR-n8UhcSTXHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_7ddcc7422abf30190d66c063",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Naaman Forest High School",
      "poi_type": "Education",
      "poi_address": "4843 Naaman Forest Blvd, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-1b1f-738b-b72c-f7f7452ce8cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1b1f-738b-b72c-f7f7452ce8cb",
        "storage_key": "property/6767906449167743/01a03e5c-1b1f-738b-b72c-f7f7452ce8cb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garlandisdschools.net/nfhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=9390641830007605611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "naaman-forest-high-school",
      "poi_latitude": "32.95787840000001",
      "poi_longitude": "-96.6377163",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-675-3091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-d7hIUkcTIYRawmHmv1CUoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_0f10910f3b7776a71aaf27a8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Spring Creek Elementary",
      "poi_type": "Education",
      "poi_address": "1510 Spring Creek Dr, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-2c0a-77ad-8607-3b5a1cc8548b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-2c0a-77ad-8607-3b5a1cc8548b",
        "storage_key": "property/6767906449167743/01a03e5c-2c0a-77ad-8607-3b5a1cc8548b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.garlandisdschools.net/page.cfm?p=1325",
      "poi_directions_map_url": "https://maps.google.com/?cid=13211416309102552541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-creek-elementary",
      "poi_latitude": "32.9547099",
      "poi_longitude": "-96.6504959",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-675-3060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ29bQpjEcTIYR3SXc0yJhWLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_0beee776e26991794c5cd5d1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Webb Middle School",
      "poi_type": "Education",
      "poi_address": "1610 Spring Creek Dr, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-18df-74c1-8bef-cc1cfbe4f5ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-18df-74c1-8bef-cc1cfbe4f5ac",
        "storage_key": "property/6767906449167743/01a03e5c-18df-74c1-8bef-cc1cfbe4f5ac.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.garlandisdschools.net/page.cfm?p=578",
      "poi_directions_map_url": "https://maps.google.com/?cid=13216802771105092074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "webb-middle-school",
      "poi_latitude": "32.9535636",
      "poi_longitude": "-96.6521453",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-675-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY-9YjjEcTIYR6hEePhiEa7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_8b512f9b4b50106adfff36fc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Abbett Elementary School",
      "poi_type": "Education",
      "poi_address": "730 W Muirfield Rd, Garland, TX 75044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.garlandisdschools.net/abbett",
      "poi_directions_map_url": "https://maps.google.com/?cid=13734662071384447453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abbett-elementary-school",
      "poi_latitude": "32.9696781",
      "poi_longitude": "-96.6377006",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-675-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJico0CWocTIYR3ZnmcmJSm74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_4c0a0d0f26a283703886a4fb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Wallace Ethridge Elementary School",
      "poi_type": "Education",
      "poi_address": "2301 Sam Houston Dr, Garland, TX 75044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.garlandisdschools.net/ethridge",
      "poi_directions_map_url": "https://maps.google.com/?cid=15808744144074688156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wallace-ethridge-elementary-school",
      "poi_latitude": "32.9355201",
      "poi_longitude": "-96.6581878",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-675-3020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyVQDodAdTIYRnMabbArxY9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_61ab220f3da1d2c1e4f2aceb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Cooper Elementary School",
      "poi_type": "Education",
      "poi_address": "1200 Kingsbridge Dr, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.garlandisdschools.net/cooper",
      "poi_directions_map_url": "https://maps.google.com/?cid=5599025983484408066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cooper-elementary-school",
      "poi_latitude": "32.934407",
      "poi_longitude": "-96.645439",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-675-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs1nwRcYdTIYRAjHFkXe8s00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_dc19084b988bcdd18494dbbd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "The Goddard School of Garland",
      "poi_type": "Education",
      "poi_address": "5760 N Garland Ave, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-1680-743d-afa7-a41bf0c59743.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1680-743d-afa7-a41bf0c59743",
        "storage_key": "property/6767906449167743/01a03e5c-1680-743d-afa7-a41bf0c59743.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.goddardschool.com/schools/tx/garland/garland?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=2831817246622462372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-garland",
      "poi_latitude": "32.9678795",
      "poi_longitude": "-96.6399632",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-372-9530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQyiy9CgdTIYRpLHBPciiTCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_fc7962af8b84323b6ddeef21",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Imagination Station",
      "poi_type": "Education",
      "poi_address": "1966 Arapaho Rd, Garland, TX 75044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://imaginationstationtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2705865189037632340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "imagination-station",
      "poi_latitude": "32.9545232",
      "poi_longitude": "-96.6581397",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-414-4971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX1vj2S4cTIYRVOuumg0qjSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_0bc98fa295152570ce78f35e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Dallas College Garland Center",
      "poi_type": "Education",
      "poi_address": "675 W Walnut St, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-1fce-77cf-9ec2-68cb659cc76b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1fce-77cf-9ec2-68cb659cc76b",
        "storage_key": "property/6767906449167743/01a03e5c-1fce-77cf-9ec2-68cb659cc76b.webp",
        "width": 1100,
        "height": 732
      },
      "poi_business_url": "https://www.dallascollege.edu/locations/garland/?utm_source=local&utm_medium=organic&utm_campaign=gmb&utm_content=rlc%20garland",
      "poi_directions_map_url": "https://maps.google.com/?cid=14622817491921357359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-college-garland-center",
      "poi_latitude": "32.9170275",
      "poi_longitude": "-96.6385272",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-360-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu8BrSpIdTIYRL0pXrQiv7so",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_268d9cee7adcde832d4aff26",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "AMC Firewheel 18",
      "poi_type": "Entertainment",
      "poi_address": "100 Coneflower Dr, Garland, TX 75040, USA",
      "poi_short_description": "Chain movie theater in Firewheel Town Center with IMAX, Dolby Cinema, and Dine-In options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-2d75-73de-8414-642c933d5e9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-2d75-73de-8414-642c933d5e9c",
        "storage_key": "property/6767906449167743/01a03e5c-2d75-73de-8414-642c933d5e9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/dallas-ft-worth/amc-firewheel-18?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1082600335928098491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-firewheel-18",
      "poi_latitude": "32.9506591",
      "poi_longitude": "-96.61410010000002",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-530-2262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-a615-7788-a058-0c436509ffbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a615-7788-a058-0c436509ffbc",
        "storage_key": "property/6767906449167743/01a03e5c-a615-7788-a058-0c436509ffbc.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62xFo_0cTIYRu362CEUrBg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_202784ca6e85717e16c1619b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Hawaiian Waters Garland",
      "poi_type": "Entertainment",
      "poi_address": "4550 N Garland Ave, Garland, TX 75040, USA",
      "poi_short_description": "Branch of a chain of water parks with slides, rides, lazy river & a 16,000-sq.-ft. wave pool.",
      "poi_long_description": "Branch of a chain of water parks with slides, rides, lazy river & a 16,000-sq.-ft. wave pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e59-8173-722e-9a78-4d5ec7a47346.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-8173-722e-9a78-4d5ec7a47346",
        "storage_key": "property/6767906449167743/01a03e59-8173-722e-9a78-4d5ec7a47346.webp",
        "width": 680,
        "height": 451
      },
      "poi_business_url": "http://www.hawaiianwaters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11586946791377660959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hawaiian-waters-garland",
      "poi_latitude": "32.9565022",
      "poi_longitude": "-96.650861",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-905-9925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2R2tEzAcTIYRH-xqa7cazaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_d924dc98f756e8c5f374b332",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Firewheel Golf Park Bridges Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1535 E Brand Rd, Garland, TX 75044, USA",
      "poi_short_description": "Golf course with 3 9-hole courses that rotate as 2 full 18s; some holes have Bermuda greens.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-2d8d-733a-a433-90a3276c1daf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-2d8d-733a-a433-90a3276c1daf",
        "storage_key": "property/6767906449167743/01a03e5c-2d8d-733a-a433-90a3276c1daf.webp",
        "width": 1280,
        "height": 941
      },
      "poi_business_url": "http://www.golffirewheel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11693391259143359582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firewheel-golf-park-bridges-course",
      "poi_latitude": "32.9676771",
      "poi_longitude": "-96.6207355",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-205-3651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8281-7167-abf9-5e8276125ec5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8281-7167-abf9-5e8276125ec5",
        "storage_key": "property/6767906449167743/01a03e5a-8281-7167-abf9-5e8276125ec5.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJuSLYgfUcTIYRXszlXGVFR6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_d73b81b6400a4074de5d0ea7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Granville Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "300 N 5th St, Garland, TX 75040, USA",
      "poi_short_description": "Arts complex with 2 auditoriums & other spaces hosting concerts & theatrical productions.",
      "poi_long_description": "Arts complex with 2 auditoriums & other spaces hosting concerts & theatrical productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-3ad9-7604-9112-98712aa85ffd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-3ad9-7604-9112-98712aa85ffd",
        "storage_key": "property/6767906449167743/01a03e5c-3ad9-7604-9112-98712aa85ffd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://garlandarts.com/4060/Arts",
      "poi_directions_map_url": "https://maps.google.com/?cid=18291813425782077565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "granville-arts-center",
      "poi_latitude": "32.9149998",
      "poi_longitude": "-96.6359915",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-205-2780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_tdzpEdTIYRfTh2hWWT2f0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_d8526fc60503efa53384b036",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Plaza Garland",
      "poi_type": "Shopping & Retail",
      "poi_address": "3161 Broadway Blvd, Garland, TX 75043, USA",
      "poi_short_description": "Sprawling shopping area featuring Mexican restaurants and clothing stores resembling a marketplace.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-36ee-75ad-8178-41f1e127342c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-36ee-75ad-8178-41f1e127342c",
        "storage_key": "property/6767906449167743/01a03e5c-36ee-75ad-8178-41f1e127342c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.plazagarland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8191232655762750570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plaza-garland",
      "poi_latitude": "32.8771868",
      "poi_longitude": "-96.621263",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 469-562-4939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8172-75a1-9af2-44e775a21aea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8172-75a1-9af2-44e775a21aea",
        "storage_key": "property/6767906449167743/01a03e5a-8172-75a1-9af2-44e775a21aea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJefzrFgqnToYRanxRj7MarXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_c9a9cc5ac6ac86a13f3cb8df",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Lucky Strike Garland",
      "poi_type": "Entertainment",
      "poi_address": "1950 Marketplace Dr, Garland, TX 75041, USA",
      "poi_short_description": "Upscale entertainment destination with bowling, craft food & cocktails, plus lively arcades.",
      "poi_long_description": "Upscale entertainment destination with bowling, craft food & cocktails, plus lively arcades.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-3f8a-7648-841e-658f20cf9290.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-3f8a-7648-841e-658f20cf9290",
        "storage_key": "property/6767906449167743/01a03e5c-3f8a-7648-841e-658f20cf9290.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.luckystrikeent.com/location/lucky-strike-garland?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12501230388601058916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-strike-garland",
      "poi_latitude": "32.8629245",
      "poi_longitude": "-96.6544196",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 972-613-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98f_ySinToYRZHbi181Kfa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "ec_3e0881f62b6ff494ea39f6dc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Texas Skatium",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2020 Rowlett Rd, Garland, TX 75043, USA",
      "poi_short_description": "Family-friendly spot featuring a rink for roller-skating or rollerblading, plus bounce houses and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-4541-73cb-9992-ff2b1f25e9bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4541-73cb-9992-ff2b1f25e9bf",
        "storage_key": "property/6767906449167743/01a03e5c-4541-73cb-9992-ff2b1f25e9bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://texasskatium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9621759283967158298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-skatium",
      "poi_latitude": "32.8611582",
      "poi_longitude": "-96.5758781",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 972-240-6455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ6I2h4CoToYRGugtKxdbh4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "ec_1a5357da1cda41ec7d6f951e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Surf & Swim",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "440 W Oates Rd, Garland, TX 75043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-4f2e-7481-af82-f26cfc035c05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4f2e-7481-af82-f26cfc035c05",
        "storage_key": "property/6767906449167743/01a03e5c-4f2e-7481-af82-f26cfc035c05.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.garlandtx.gov/3454/Surf-Swim",
      "poi_directions_map_url": "https://maps.google.com/?cid=17796337152363421502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "surf--swim",
      "poi_latitude": "32.8471095",
      "poi_longitude": "-96.6148846",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 972-205-3993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8241-71ae-b305-67521b593270",
        "storage_key": "property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnTOWAgCnToYRPl-13VlK-fY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b3162ee049653b01463b63f7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Spring Creek Forest Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1770 Holford Rd, Garland, TX 75044, USA",
      "poi_short_description": "This scenic park known for its towering trees, wildflowers & rare plants features trails & a creek.",
      "poi_long_description": "This scenic park known for its towering trees, wildflowers & rare plants features trails & a creek.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-3eb4-72c5-9ba8-bdc5869592f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-3eb4-72c5-9ba8-bdc5869592f8",
        "storage_key": "property/6767906449167743/01a03e5c-3eb4-72c5-9ba8-bdc5869592f8.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.springcreekforest.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9677198873188912901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-creek-forest-preserve",
      "poi_latitude": "32.9652529",
      "poi_longitude": "-96.6535453",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8241-71ae-b305-67521b593270",
        "storage_key": "property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWRGRjscTIYRBU88aRpRTIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_f5b9e430a44a8b8cceaad9ac",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Baylor Scott & White Family Medical Center - North Garland",
      "poi_type": "Health and Wellness",
      "poi_address": "7217 Telecom Pkwy STE 100, Garland, TX 75044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-4482-71f7-b356-9794044d344a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4482-71f7-b356-9794044d344a",
        "storage_key": "property/6767906449167743/01a03e5c-4482-71f7-b356-9794044d344a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/clinic/family-medical-center-north-garland?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-9717620",
      "poi_directions_map_url": "https://maps.google.com/?cid=17646988345027565880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-family-medical-center---north-garland",
      "poi_latitude": "32.9819535",
      "poi_longitude": "-96.6625591",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 469-800-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0lZO-IdTIYROJnT7Gay5vQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_57d9544f06388dc977148edc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Baylor Scott & White Urgent Care + Garland (Garland Ave)",
      "poi_type": "Health and Wellness",
      "poi_address": "5302 N Garland Ave Ste 100, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-5569-739e-b681-04a6f2dbaf67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-5569-739e-b681-04a6f2dbaf67",
        "storage_key": "property/6767906449167743/01a03e5c-5569-739e-b681-04a6f2dbaf67.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bswhealth.com/locations/urgent-care/uc-plus-garland?utm_source=google-mybusiness&utm_medium=organic&utm_campaign=UC+GarlandAve&utm_content=main-website",
      "poi_directions_map_url": "https://maps.google.com/?cid=15180422466593984584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-urgent-care--garland-garland-ave",
      "poi_latitude": "32.962819",
      "poi_longitude": "-96.642842",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-431-0692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28rEn_cdTIYRSJCx1c2xq9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_a2260f962e28f241313ede32",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5302 N Garland Ave, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-4a89-7239-8a70-c15775215ef7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4a89-7239-8a70-c15775215ef7",
        "storage_key": "property/6767906449167743/01a03e5c-4a89-7239-8a70-c15775215ef7.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/1055-garland-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17798699730597075959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "32.9625151",
      "poi_longitude": "-96.6432209",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-495-2515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-a613-73cb-a523-5351a4cffe94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a613-73cb-a523-5351a4cffe94",
        "storage_key": "property/6767906449167743/01a03e5c-a613-73cb-a523-5351a4cffe94.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqWPSzjgcTIYR91sUehqvAfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_cdec5e9df9e93387e683c75d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Tom Thumb Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2535 Firewheel Pkwy, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-5b32-7658-92d0-47b6a938c49e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-5b32-7658-92d0-47b6a938c49e",
        "storage_key": "property/6767906449167743/01a03e5c-5b32-7658-92d0-47b6a938c49e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.pharmacy.tomthumb.com/tx/garland/2535-firewheel-pkwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5346529667662903119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb-pharmacy",
      "poi_latitude": "32.9374229",
      "poi_longitude": "-96.605562",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-675-1742",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-a613-73cb-a523-5351a4cffe94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a613-73cb-a523-5351a4cffe94",
        "storage_key": "property/6767906449167743/01a03e5c-a613-73cb-a523-5351a4cffe94.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwxNVshAdTIYRT3ci1mewMko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_f96cac35bc6b2535a36a643c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "5602 Naaman Forest Blvd, Garland, TX 75044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-2c37-77ee-8b69-ece4c6cc0784.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-2c37-77ee-8b69-ece4c6cc0784",
        "storage_key": "property/6767906449167743/01a03e5a-2c37-77ee-8b69-ece4c6cc0784.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lifetime.life/locations/tx/garland.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=689121118446773237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "32.9645038",
      "poi_longitude": "-96.6480276",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-496-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsehy2TscTIYR9WM9kAFAkAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_e87a934a55248d3804fe7c96",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2380 Firewheel Pkwy, Garland, TX 75040, USA",
      "poi_short_description": "Chain gym with 24/7 access providing equipment, personal training, and group workouts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-583b-720f-92a1-cd11e5955bf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-583b-720f-92a1-cd11e5955bf8",
        "storage_key": "property/6767906449167743/01a03e5c-583b-720f-92a1-cd11e5955bf8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/garland-texas-1193/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=1193",
      "poi_directions_map_url": "https://maps.google.com/?cid=8167001674029837863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "32.9359331",
      "poi_longitude": "-96.6002172",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-495-6565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4jtLxYdTIYRJ66RfMAEV3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ad3389c1a202fc84a61bca2c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 W Centerville Rd, Garland, TX 75041, USA",
      "poi_short_description": "Chain gym offering a pool, basketball court, and sauna, plus classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-5354-75ee-8c22-c958c66ecaab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-5354-75ee-8c22-c958c66ecaab",
        "storage_key": "property/6767906449167743/01a03e5c-5354-75ee-8c22-c958c66ecaab.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=926&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6951196607411046301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "32.8578216",
      "poi_longitude": "-96.6478353",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 972-271-4614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdYqhiGnToYRnceiRHycd2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_3ecfadea062e502947fb6ec1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "HOTWORX- Garland, TX",
      "poi_type": "Health and Wellness",
      "poi_address": "2535 Firewheel Pkwy Ste 300, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-6038-76a0-bf1c-116ae79c33c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-6038-76a0-bf1c-116ae79c33c1",
        "storage_key": "property/6767906449167743/01a03e5c-6038-76a0-bf1c-116ae79c33c1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hotworx.net/studio/garland?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9414981164696348870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx--garland-tx",
      "poi_latitude": "32.9373984",
      "poi_longitude": "-96.6055375",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-318-2832",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmxugCrodTIYRxii4kHy7qII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_46addf731cc68fe70aa29842",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Halff Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4695, Ranger Dr, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-6f79-70ac-86ea-2798a4b50259.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-6f79-70ac-86ea-2798a4b50259",
        "storage_key": "property/6767906449167743/01a03e5c-6f79-70ac-86ea-2798a4b50259.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://garlandtx.gov/Facilities/Facility/Details/Halff-Park-40",
      "poi_directions_map_url": "https://maps.google.com/?cid=13051465604496641724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "halff-park",
      "poi_latitude": "32.9550902",
      "poi_longitude": "-96.6373993",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8241-71ae-b305-67521b593270",
        "storage_key": "property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJedgYNEkcTIYRvE5AUtEeILU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c27b21d3ae3be09895193383",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Spring Creek Greenbelt - Fred E. Harris Section",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Mapleridge, Garland texas, 6006 N Shiloh Rd, Garland, TX 75044, USA",
      "poi_short_description": "Scenic natural area with shady trees, a pond & fishing pier, a playground & picnic tables.",
      "poi_long_description": "Scenic natural area with shady trees, a pond & fishing pier, a playground & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-74ec-71be-b6d5-626a048f3085.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-74ec-71be-b6d5-626a048f3085",
        "storage_key": "property/6767906449167743/01a03e5c-74ec-71be-b6d5-626a048f3085.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.garlandtx.gov/facilities/facility/details/springcreekgreenbelt-harrissection-64",
      "poi_directions_map_url": "https://maps.google.com/?cid=17829069335480626558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-creek-greenbelt---fred-e-harris-section",
      "poi_latitude": "32.9701378",
      "poi_longitude": "-96.6629482",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8241-71ae-b305-67521b593270",
        "storage_key": "property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3Q29qAeTIYRfu0hIRmUbfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_ea60c5deb2c806cd7235770c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Winters Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1330 Spring Creek Dr, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-695a-773a-aab0-7da1f61a9005.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-695a-773a-aab0-7da1f61a9005",
        "storage_key": "property/6767906449167743/01a03e5c-695a-773a-aab0-7da1f61a9005.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://garlandtx.gov/Facilities/Facility/Details/Winters-Park-72",
      "poi_directions_map_url": "https://maps.google.com/?cid=8684014823093890653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winters-park",
      "poi_latitude": "32.9546127",
      "poi_longitude": "-96.6537428",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8241-71ae-b305-67521b593270",
        "storage_key": "property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbbUTXvQdTIYRXe68wnjRg3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b46abf2f975e8ed718386256",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Rowlett Creek - Dallas County Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2525 Castle Dr, Garland, TX 75040, USA",
      "poi_short_description": "This park known for its bicycle trails also offers a pavilion, grill & picnic tables.",
      "poi_long_description": "This park known for its bicycle trails also offers a pavilion, grill & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-7d99-747e-9fb8-6d02d47c5437.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-7d99-747e-9fb8-6d02d47c5437",
        "storage_key": "property/6767906449167743/01a03e5c-7d99-747e-9fb8-6d02d47c5437.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.dallascounty.org/departments/plandev/openspaces/locations/05-rowlett-creek.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=4461175981870784767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowlett-creek---dallas-county-nature-preserve",
      "poi_latitude": "32.9199291",
      "poi_longitude": "-96.5958299",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8241-71ae-b305-67521b593270",
        "storage_key": "property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGQcrs0AdTIYR_6DpT-tH6T0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_6acb94d27d1769adc7bc24a5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Duck Creek Greenbelt",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4917 Duck Creek Dr, Garland, TX 75043, USA",
      "poi_short_description": "Green, tree-lined park featuring paved trails for cycling and walking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-693b-7360-93c2-a7c27df63dbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-693b-7360-93c2-a7c27df63dbe",
        "storage_key": "property/6767906449167743/01a03e5c-693b-7360-93c2-a7c27df63dbe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.garlandtx.gov/facilities/facility/details/Duck-Creek-Greenbelt-Trail-128",
      "poi_directions_map_url": "https://maps.google.com/?cid=11972029897799461499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duck-creek-greenbelt",
      "poi_latitude": "32.8526976",
      "poi_longitude": "-96.6121716",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8241-71ae-b305-67521b593270",
        "storage_key": "property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm58ykVGmToYRe2qx8sIxJaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_fdd4f6fdc6ce2e84926ca453",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Bradfield Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1220 Castle Dr, Garland, TX 75040, USA",
      "poi_short_description": "Public recreation center offering fitness & enrichment classes for adults & children.",
      "poi_long_description": "Public recreation center offering fitness & enrichment classes for adults & children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-8953-7197-8389-2ac11734728a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-8953-7197-8389-2ac11734728a",
        "storage_key": "property/6767906449167743/01a03e5c-8953-7197-8389-2ac11734728a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://garlandtx.gov/Facilities/Facility/Details/Bradfield-Park-21",
      "poi_directions_map_url": "https://maps.google.com/?cid=10767032649514863638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bradfield-park",
      "poi_latitude": "32.921178",
      "poi_longitude": "-96.6183671",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-205-2770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8241-71ae-b305-67521b593270",
        "storage_key": "property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWQ3hJ3QdTIYRFsxdByYvbJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_87ff5e87abf90c30384de9eb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "John Paul Jones Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4099 Zion Rd, Garland, TX 75043, USA",
      "poi_short_description": "Popular waterfront park with picnic areas, grills, fishing piers & restrooms.",
      "poi_long_description": "Popular waterfront park with picnic areas, grills, fishing piers & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-7b3a-7277-ba27-7eb99792ba89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-7b3a-7277-ba27-7eb99792ba89",
        "storage_key": "property/6767906449167743/01a03e5c-7b3a-7277-ba27-7eb99792ba89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://garlandtx.gov/Facilities/Facility/Details/John-Paul-Jones-Park-49",
      "poi_directions_map_url": "https://maps.google.com/?cid=15009101061326681911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-paul-jones-park",
      "poi_latitude": "32.86268829999999",
      "poi_longitude": "-96.5515007",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8241-71ae-b305-67521b593270",
        "storage_key": "property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsel1qlioToYRN7dQxuQJS9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_394bf278499a26b33578570e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "One Eleven Ranch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2121 E Brand Rd, Garland, TX 75044, USA",
      "poi_short_description": "Park featuring barbecue grills and picnic tables, plus a playground, gazebo and slide.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-7ff0-757f-88a8-68b833d03326.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-7ff0-757f-88a8-68b833d03326",
        "storage_key": "property/6767906449167743/01a03e5c-7ff0-757f-88a8-68b833d03326.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://garlandtx.gov/facilities/facility/details/One-Eleven-Ranch-Park-56",
      "poi_directions_map_url": "https://maps.google.com/?cid=17379128893798806269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-eleven-ranch-park",
      "poi_latitude": "32.9722544",
      "poi_longitude": "-96.6257318",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8241-71ae-b305-67521b593270",
        "storage_key": "property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Vngr2AcTIYR_fKafKYRL_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_a509975905c6faa141504702",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Windsurf Bay Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5556 Locust Grove Rd, Garland, TX 75043, USA",
      "poi_short_description": "Grassy area on Lake Ray Hubbard with a playground, picnic pavilion, BBQ grill & sports courts.",
      "poi_long_description": "Grassy area on Lake Ray Hubbard with a playground, picnic pavilion, BBQ grill & sports courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-89af-7470-89ff-15db0c4cd11b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-89af-7470-89ff-15db0c4cd11b",
        "storage_key": "property/6767906449167743/01a03e5c-89af-7470-89ff-15db0c4cd11b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.garlandtx.gov/facilities/facility/details/Windsurf-Bay-Park-71",
      "poi_directions_map_url": "https://maps.google.com/?cid=3080426441672512539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windsurf-bay-park",
      "poi_latitude": "32.8498",
      "poi_longitude": "-96.5476",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 48 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8241-71ae-b305-67521b593270",
        "storage_key": "property/6767906449167743/01a03e5a-8241-71ae-b305-67521b593270.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWVmlu-oToYRG1ScJIffvyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_c16b587f3195457779bc6217",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Forest / Jupiter",
      "poi_type": "Transportation & Transit",
      "poi_address": "3232 Forest Ln, Garland, TX 75042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-5d13-77b0-a0ff-841482f569e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-5d13-77b0-a0ff-841482f569e9",
        "storage_key": "property/6767906449167743/01a03e5a-5d13-77b0-a0ff-841482f569e9.webp",
        "width": 852,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/riding/stations/forestjupiterstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=18241006461951380148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest--jupiter",
      "poi_latitude": "32.9081082",
      "poi_longitude": "-96.6793834",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8668-76a9-bd69-c14ee28268f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8668-76a9-bd69-c14ee28268f9",
        "storage_key": "property/6767906449167743/01a03e5a-8668-76a9-bd69-c14ee28268f9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoXHJ2hseTIYRtIo3brsSJf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_8cc5035338a2d4eed972b3cd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Downtown Garland Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "430 W Walnut St, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-8ffc-722e-b2b3-aa2091b7e0b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-8ffc-722e-b2b3-aa2091b7e0b2",
        "storage_key": "property/6767906449167743/01a03e5c-8ffc-722e-b2b3-aa2091b7e0b2.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4772984402673695142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-garland-station",
      "poi_latitude": "32.9174029",
      "poi_longitude": "-96.6357499",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-a621-74be-b50d-f6aeb3d66c37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a621-74be-b50d-f6aeb3d66c37",
        "storage_key": "property/6767906449167743/01a03e5c-a621-74be-b50d-f6aeb3d66c37.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJZeDPD5EdTIYRpnnYnwYMPUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_cdd8790da6308a4a07fc495a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Lake Ray Hubbard Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "6151 Duck Creek Dr, Garland, TX 75043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-8bf6-753d-8dd8-ec5447e80ce5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-8bf6-753d-8dd8-ec5447e80ce5",
        "storage_key": "property/6767906449167743/01a03e5c-8bf6-753d-8dd8-ec5447e80ce5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/riding/stations/lakerayhubbardtransitcenter.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=12088869112523893110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-ray-hubbard-transit-center",
      "poi_latitude": "32.8430801",
      "poi_longitude": "-96.6016047",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-a617-734f-9c39-6154013bc406.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a617-734f-9c39-6154013bc406",
        "storage_key": "property/6767906449167743/01a03e5c-a617-734f-9c39-6154013bc406.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95_TDUemToYRdqkthGhKxKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_557420e52cab7435736a9980",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "South Garland Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4051 Leon Rd, Garland, TX 75041, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-95d7-7086-b9fd-830efcf41432.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-95d7-7086-b9fd-830efcf41432",
        "storage_key": "property/6767906449167743/01a03e5c-95d7-7086-b9fd-830efcf41432.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/riding/stations/southgarlandtransitcenter.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14878736467210160186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-garland-transit-center",
      "poi_latitude": "32.868086",
      "poi_longitude": "-96.6631265",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-a617-734f-9c39-6154013bc406.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a617-734f-9c39-6154013bc406",
        "storage_key": "property/6767906449167743/01a03e5c-a617-734f-9c39-6154013bc406.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJTyQQpjKnToYROki2avzje84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_b9e3e756ec9c89c1124c3792",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Downtown Rowlett",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 Martin Dr, Rowlett, TX 75088, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-9c07-71db-9131-8bdbe6d9e68f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9c07-71db-9131-8bdbe6d9e68f",
        "storage_key": "property/6767906449167743/01a03e5c-9c07-71db-9131-8bdbe6d9e68f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.dart.org/riding/stations/downtownrowlettstation.asp?zeon=blue",
      "poi_directions_map_url": "https://maps.google.com/?cid=11066164895002160789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-rowlett",
      "poi_latitude": "32.9041373",
      "poi_longitude": "-96.5634519",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-8668-76a9-bd69-c14ee28268f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8668-76a9-bd69-c14ee28268f9",
        "storage_key": "property/6767906449167743/01a03e5a-8668-76a9-bd69-c14ee28268f9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJaak9tR2oToYRlW6ASFfqkpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_4272808bb8fd9290f23a7e0b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-99b5-7764-9a1c-7cc13ad1e5b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-99b5-7764-9a1c-7cc13ad1e5b6",
        "storage_key": "property/6767906449167743/01a03e5c-99b5-7764-9a1c-7cc13ad1e5b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "27.9 mi",
      "poi_walking_minutes": "10 hours 23 mins",
      "poi_biking_minutes": "2 hours 56 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-a62b-759e-bbf4-522aea764d17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a62b-759e-bbf4-522aea764d17",
        "storage_key": "property/6767906449167743/01a03e5c-a62b-759e-bbf4-522aea764d17.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_78b6e59c9fcf5dc4c5958962",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Garland VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2300 Marie Curie Blvd, Garland, TX 75042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-1d59-756a-931f-0f5f05ac2c65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-1d59-756a-931f-0f5f05ac2c65",
        "storage_key": "property/6767906449167743/01a03e5a-1d59-756a-931f-0f5f05ac2c65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northtexas.va.gov/locations/Garland_VAMC.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=4557347573635622006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garland-va-medical-center",
      "poi_latitude": "32.9193128",
      "poi_longitude": "-96.6626672",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-797-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81ca-70fc-817d-8263b3fd250d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81ca-70fc-817d-8263b3fd250d",
        "storage_key": "property/6767906449167743/01a03e5a-81ca-70fc-817d-8263b3fd250d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_4-cOPIdTIYRdiSK7HjzPj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_580b2a488d791bd3e01b1e2b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Garland Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "501 S Jupiter Rd, Garland, TX 75042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-9561-7095-bd2e-e0ccca7a9c4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9561-7095-bd2e-e0ccca7a9c4f",
        "storage_key": "property/6767906449167743/01a03e5c-9561-7095-bd2e-e0ccca7a9c4f.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://www.garlandisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=557013818549010741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garland-independent-school-district",
      "poi_latitude": "32.9086679",
      "poi_longitude": "-96.6835931",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 972-494-8201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7W6qUpunToYRNQGZ5R3pugc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_60ca605c9c9919d4b2de92a5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Garland City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 N 5th St, Garland, TX 75040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-9b97-74fe-8343-1fcfd8a192f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9b97-74fe-8343-1fcfd8a192f0",
        "storage_key": "property/6767906449167743/01a03e5c-9b97-74fe-8343-1fcfd8a192f0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.garlandtx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16316639176539699962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garland-city-hall",
      "poi_latitude": "32.9136369",
      "poi_longitude": "-96.6362934",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-205-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-a624-715d-a16c-189d9ebe4ee7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-a624-715d-a16c-189d9ebe4ee7",
        "storage_key": "property/6767906449167743/01a03e5c-a624-715d-a16c-189d9ebe4ee7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR-cZG44dTIYR-vreveFYcOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_fdae0158d19838a90d904259",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Kraft Heinz-Garland",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2340 Forest Ln, Garland, TX 75042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-9e01-7191-a441-fcd47b0b08fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9e01-7191-a441-fcd47b0b08fa",
        "storage_key": "property/6767906449167743/01a03e5c-9e01-7191-a441-fcd47b0b08fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kraftheinz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12649827594219737775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kraft-heinz-garland",
      "poi_latitude": "32.9079075",
      "poi_longitude": "-96.6636842",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 214-703-1752",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdq_8v4dTIYRr9Jm3yw3ja8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "ec_a56cb9fb94aa37c74bdaaf00",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "US Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1992 Forest Ln, Garland, TX 75042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-9f9e-7209-9245-1f51f58682d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9f9e-7209-9245-1f51f58682d1",
        "storage_key": "property/6767906449167743/01a03e5c-9f9e-7209-9245-1f51f58682d1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.usfoods.com/locations/restaurant-supplier-in-dallas--tx.html?utm_medium=organic&utm_source=google_business_profile&utm_campaign=garland_tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9849642847457414068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-foods",
      "poi_latitude": "32.9079271",
      "poi_longitude": "-96.6578581",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 972-487-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRc3h9QAeTIYRtIsq7_v1sIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wholesaler"
    },
    {
      "id": "ec_43fd0fbc31bdfbfbacbb1da3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "FedEx Ship Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "3242 Herrmann Dr, Garland, TX 75041, USA",
      "poi_short_description": "Chain store offering shipping services, as well as packing supplies and pickup options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-9944-7118-9c9a-346dc1bbb57f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9944-7118-9c9a-346dc1bbb57f",
        "storage_key": "property/6767906449167743/01a03e5c-9944-7118-9c9a-346dc1bbb57f.webp",
        "width": 1226,
        "height": 690
      },
      "poi_business_url": "https://local.fedex.com/en-us/tx/garland/gvta?cmp=LOC-1001545-3-2-971-1110000-US-US-EN-YEXTLISTFEDEXSC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5584246976583730656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fedex-ship-center",
      "poi_latitude": "32.892478",
      "poi_longitude": "-96.679324",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-463-3339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT9xccaSgToYR4IVS4Qk7f00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shipping_service"
    },
    {
      "id": "ec_34bd551d04abe405758afb2b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Amazon Flex Delivery Fullfillment Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3900 Distribution Dr, Garland, TX 75041, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-9ded-734e-a79d-35ac307f54bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9ded-734e-a79d-35ac307f54bb",
        "storage_key": "property/6767906449167743/01a03e5c-9ded-734e-a79d-35ac307f54bb.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7573994606176102518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-flex-delivery-fullfillment-center",
      "poi_latitude": "32.8930671",
      "poi_longitude": "-96.6871478",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 214-742-0662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Y4zJJmgToYRdujZL_c7HGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "ec_c62e8b2fde73eb03923142ac",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "Texas Instruments Incorporated - South Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12500 T I Blvd, Dallas, TX 75243, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-9da9-77a8-8422-09f631ed2704.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9da9-77a8-8422-09f631ed2704",
        "storage_key": "property/6767906449167743/01a03e5c-9da9-77a8-8422-09f631ed2704.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ti.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18005343530910950488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-instruments-incorporated---south-campus",
      "poi_latitude": "32.9132404",
      "poi_longitude": "-96.7524391",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 855-226-3113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-81b5-72e9-b18e-bd63337f5222",
        "storage_key": "property/6767906449167743/01a03e5a-81b5-72e9-b18e-bd63337f5222.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQx5jxsgTIYRWCTTgovU3_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supplier"
    },
    {
      "id": "ec_61af832250a4e40fb98cbc55",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "poi_name": "The University of Texas at Dallas",
      "poi_type": "Education",
      "poi_address": "800 W Campbell Rd, Richardson, TX 75080, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e59-742f-74bb-9f6d-89a8c52f54aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-742f-74bb-9f6d-89a8c52f54aa",
        "storage_key": "property/6767906449167743/01a03e59-742f-74bb-9f6d-89a8c52f54aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.utdallas.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15639184231805621041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-dallas",
      "poi_latitude": "32.9859295",
      "poi_longitude": "-96.7503304",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-883-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-827e-722c-aa2e-bf8d59d556a6",
        "storage_key": "property/6767906449167743/01a03e5a-827e-722c-aa2e-bf8d59d556a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpUpeif8hTIYRMROq6TKLCdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "ec_c6adf654524c0bed434d8cc9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_99ae83ef00bf9cac4edea2de",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "ec_41ad4151801454ad6fb9b018",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "ec_5f80d1cfadbd603721030458",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2642be0ce3f43dedb5d33389",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2c399e6e938ca73e7c7bb50d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_84f9278dbe5350bcc0270cb7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "rating": "5",
      "name": "false",
      "text": "I have been living at The REVE for about a week and I absolutely love it here! The community is very nice and sits in a great area of town. The office staff, Michael, Claudia, and Elvis are the friendliest and are amazing! They made the move in process so easy! They have a stellar maintenance team that will answer your request within 24 hrs if that long. If you are looking for an apartment, Property manager Arlene i believe that is her name, is the jam to the community, I highly recommend The Reve!\n",
      "date": "false",
      "title": "Live at the Reve with me!!"
    },
    {
      "id": "ec_5814285a4edffd3c8da90591",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "rating": "4",
      "name": "false",
      "text": "I have lived here two years and the property managers are constantly working to improve the experience. Great location, near some great restaraunts. May consider renewing my lease . ",
      "date": "false",
      "title": "Great Management"
    },
    {
      "id": "ec_21cbe1e461b28e69b42b2c7a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "rating": "5",
      "name": "false",
      "text": "Really impressed with this community! It is well cared for, welcoming, and a place where a lot of thought goes into creating a great environment for residents. Definitely worth checking out if you’re looking for a place in the area!",
      "date": "false",
      "title": "Impressed"
    },
    {
      "id": "ec_3a15fdf6eb23941943838585",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "rating": "5",
      "name": "false",
      "text": "This is a great place to live! The apartments have beautiful, modern finishes, the common areas are always clean and well-maintained, and the management team is friendly, approachable, and easy to work with. It’s clear they take pride in the community and care about their residents.",
      "date": "false",
      "title": "Lovely Property!"
    },
    {
      "id": "ec_c30c517505fa02f6b8d6a6fc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "rating": "5",
      "name": "false",
      "text": "I’ve had a very positive experience with the management at this apartment complex. The manager is professional, friendly, and responsive to residents’ concerns. They communicate clearly, address issues in a timely manner, and genuinely seem to care about creating a comfortable and welcoming community.\n\nI especially appreciate their willingness to listen and help resolve problems when they arise. Their professionalism and dedication make a noticeable difference in the overall living experience.\n\nOverall, I would highly recommend this apartment community, and I’m grateful to have a manager who is attentive, approachable, and committed to providing great service.",
      "date": "false",
      "title": "Great Management and Excellent Resident Service"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-garland-tx",
      "search_query": "pet friendly apartments in Garland TX",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Garland, TX",
      "h2_subtitle": "Discover pet-friendly living at Homestead in Garland, TX. Our community offers studios, one, two, and three bedroom layouts that cater to pet enthusiasts.",
      "page_copy": "Welcome to Homestead, a premier choice for those seeking pet friendly apartments in Garland, TX. Nestled conveniently near Richardson, our elegant studio, one, two, and three-bedroom residences not only provide luxurious living spaces but also embrace pet-friendly living. With thoughtful amenities like air conditioning, a 24-hour resident package system, and trash pickup right at your door, you and your furry companions will enjoy unparalleled comfort.\n\nLocated in the vibrant neighborhood of Garland, Homestead ensures you and your pets have access to the best of the city. With amenities such as 24-hour access and online resident services, you’ll experience ease and convenience in an environment that welcomes your entire family, furry members included. Immerse yourself in a community that values what you love, all while enjoying a residence tailored to pet owners.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Garland, TX",
      "seo_description": "Explore Homestead's pet-friendly apartments in Garland, TX. Enjoy luxury living with your pets in a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-garland-75044",
      "search_query": "apartments with in unit laundry Garland 75044",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Garland",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at Homestead in Garland, 75044. Luxury living designed with your needs in mind.",
      "page_copy": "At Homestead, discover the convenience of apartments with in-unit laundry set in the thriving Garland area, 75044. Our community offers an array of spacious studio, one, two, and three-bedroom apartments that merge elegant design with practical comforts. Alongside in-unit laundry, other standout amenities include air conditioning, a 24-hour resident package system, and door-to-door trash pickup, all within a pet-friendly setting.\n\nStrategically located near Richardson, these thoughtfully-designed apartments offer more than just a home; they provide a lifestyle of ease and comfort. Residents enjoy access to 24/7 online services and seamless living experiences from move-in to daily life. Experience the ease of having in-unit laundry facilities right at your fingertips, while residing in this vibrant Garland locale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Garland",
      "seo_description": "Homestead offers apartments with in-unit laundry in Garland, 75044. Convenience meets luxury in a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartments-with-pool-dallas-county",
      "search_query": "apartments with pool Dallas County",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Dallas County",
      "h2_subtitle": "Enjoy luxurious living at Homestead in Dallas County, featuring resort-style amenities including a sparkling pool for residents to enjoy.",
      "page_copy": "Experience the pinnacle of luxury living at Homestead, where our apartments with a pool in Dallas County redefine comfort and style. Nestled in the lively city of Garland, our studio, one, two, and three-bedroom residences provide a perfect retreat with top-of-the-line amenities. The shimmering pool is just one of the many features that make Homestead an ideal choice for those seeking relaxation and a vibrant lifestyle.\n\nBeyond the stunning pool, enjoy the convenience of air conditioning, door-to-door trash pickup, and seamless 24/7 online services tailored to simplify your daily life. Whether lounging poolside or participating in community experiences, life at Homestead enriches every moment. Located near Richardson, these exceptional apartments offer access to an array of attractions in Dallas County, making Homestead the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Dallas County",
      "seo_description": "Discover Homestead's luxurious apartments with a pool in Dallas County. Enjoy resort-style amenities and vibrant living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "luxury-apartments-dog-park-near-richardson",
      "search_query": "luxury apartments with dog park near Richardson",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Dog Park Near Richardson",
      "h2_subtitle": "Explore luxurious living at Homestead, featuring a dog park near Richardson. Enjoy upscale amenities tailored for pet owners.",
      "page_copy": "Welcome to Homestead, where luxury meets pet-friendly living. Our apartments, located conveniently near Richardson, offer an exclusive dog park that caters to you and your furry friend's needs. Choose from our sophisticated studio, one, two, and three-bedroom layouts, each designed with elegant finishes and top-tier amenities, ensuring both you and your pets are pampered.\n\nApart from the dedicated dog park, our luxury community boasts features like air conditioning, a reliable door-to-door trash pickup service, and 24-hour access complete with an intuitive online resident portal. At Homestead, every detail is designed to create a seamless and enjoyable lifestyle just minutes from Richardson. Make Homestead your new home and indulge in convenience and comfort with your pets right by your side.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Dog Park Near Richardson",
      "seo_description": "Homestead offers luxury apartments with a dog park near Richardson. Discover elegant living with upscale amenities for pet lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartments-granite-countertops-garland-tx",
      "search_query": "apartments with granite countertops Garland TX",
      "category": "Amenity",
      "h1_title": "Apartments with Granite Countertops in Garland",
      "h2_subtitle": "Find your dream home at Homestead in Garland, TX, featuring spacious apartments with elegant granite countertops.",
      "page_copy": "Discover the elegance of living at Homestead, where our apartments with granite countertops in Garland, TX, set the stage for stylish and comfortable living. Our community offers distinctive studio, one, two, and three-bedroom floor plans, each providing a seamless blend of modern aesthetics and functionality.\n\nIn addition to the sophisticated granite countertops, residents enjoy a suite of first-class amenities, including air conditioning, a comprehensive door-to-door trash pickup service, and 24-hour access to online resident services. Situated near Richardson in the vibrant heart of Garland, Homestead ensures that luxury and convenience go hand-in-hand, creating a living environment that is as inviting as it is practical.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Granite Countertops in Garland",
      "seo_description": "Discover Homestead's elegant apartments with granite countertops in Garland, TX. Experience modern living with stylish amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-near-richardson",
      "search_query": "1 bedroom apartments near Richardson",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments Near Richardson",
      "h2_subtitle": "Discover stylish 1 bedroom apartments at Homestead, conveniently located near Richardson with all the comforts of home.",
      "page_copy": "At Homestead, our 1 bedroom apartments near Richardson provide the perfect blend of comfort and sophistication. Situated in Garland, TX, these spacious units offer elegant designer finishes that elevate everyday living. Whether you're looking for a serene space or a spot closer to activity, Homestead offers the ideal living arrangement with proximity to Richardson.\n\nEnjoy exclusive access to an array of amenities, including air conditioning, door-to-door trash services, and seamless online resident systems available 24/7. Experience a community that embraces both convenience and luxurious living, making every day feel extraordinary. Choose Homestead and reconnect with what matters in our thoughtfully designed 1 bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Near Richardson",
      "seo_description": "Explore Homestead's stylish 1 bedroom apartments near Richardson. Enjoy elegant finishes and convenient access to amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-garland-tx",
      "search_query": "2 bedroom apartments Garland TX",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Garland, TX",
      "h2_subtitle": "Experience spacious living in Homestead's 2 bedroom apartments, nestled in Garland, TX, and designed with your comfort in mind.",
      "page_copy": "If you're searching for 2 bedroom apartments in Garland, TX, Homestead is where you'll find style meeting function. Our community offers spacious and thoughtfully designed two-bedroom residences, perfect for those who need a bit more room to live and thrive. Conveniently located near Richardson, these apartments feature sleek designer finishes, providing a sophisticated backdrop for your lifestyle.\n\nBeyond the ample living space, residents enjoy first-rate amenities such as air conditioning for year-round comfort, a convenient door-to-door trash pickup system, and always-accessible resident services online. Homestead seamlessly blends luxury with practicality, ensuring that whether you're entertaining friends or enjoying a quiet evening at home, you have everything you need close by. Make Homestead your next home and see what sets us apart in Garland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Garland, TX",
      "seo_description": "Find modern 2 bedroom apartments at Homestead in Garland, TX. Enjoy spacious living with elegant finishes and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "3-bedroom-dallas-county-apartments",
      "search_query": "3 bedroom Dallas County apartments",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Dallas County",
      "h2_subtitle": "Explore Homestead's spacious 3 bedroom apartments, ideally located in Dallas County, offering premium comfort and style.",
      "page_copy": "Explore the expansive beauty and comfort of Homestead's 3 bedroom apartments, located in the vibrant region of Dallas County. Our community provides ample living spaces designed with both style and practicality in mind, perfect for families or those seeking extra room. Situated in Garland, TX, with easy access to Richardson, these residences offer a blend of elegant aesthetics and modern conveniences.\n\nIn addition to generous layouts, residents can enjoy top-notch amenities such as efficient air conditioning, a reliable door-to-door trash pickup system, and user-friendly online resident services available around the clock. At Homestead, luxury meets convenience, ensuring you have everything you need within reach. Experience the lifestyle you deserve in our outstanding 3 bedroom apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Dallas County",
      "seo_description": "Discover spacious 3 bedroom apartments at Homestead in Dallas County. Enjoy elegant designs and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-texas-dallas",
      "search_query": "apartments near university of texas dallas",
      "category": "School",
      "h1_title": "Apartments Near University of Texas Dallas",
      "h2_subtitle": "Find ideal living at Homestead apartments near the University of Texas Dallas, combining luxury and convenience in a prime location.",
      "page_copy": "Homestead offers the perfect solution for those seeking apartments near the University of Texas Dallas. Located just a short drive from the university, our property provides a tranquil retreat with easy access to academic life. Our community in Garland, TX, features studio, one, two, and three-bedroom options that blend modern design with comfortable living spaces, ideal for students and professionals alike.\n\nResidents at Homestead enjoy premium amenities, including round-the-clock air conditioning, efficient door-to-door trash services, and convenient online resident tools available 24/7. Experience the unique blend of peaceful living and active opportunity, making Homestead the perfect base for your academic and social engagements. Choose Homestead for a living experience that supports both work and play.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Texas Dallas",
      "seo_description": "Discover Homestead's luxury apartments near University of Texas Dallas, offering convenience, comfort, and style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartments-close-to-dallas-college-richland-garland",
      "search_query": "apartments close to dallas college richland garland",
      "category": "School",
      "h1_title": "Apartments Close to Dallas College Richland",
      "h2_subtitle": "Discover Homestead's convenient living with our apartments close to Dallas College Richland in Garland, TX, offering comfort and style.",
      "page_copy": "Homestead is your gateway to convenient living with our prime location close to Dallas College Richland in Garland, TX. Our community offers a range of studio, one, two, and three-bedroom options, designed to enhance your living experience with elegant finishes and thoughtful amenities. Whether you're a student, faculty, or staff member, you'll appreciate being just a short commute away from campus.\n\nAt Homestead, enjoy the benefit of amenities like responsive air conditioning, a hassle-free door-to-door trash pickup service, and around-the-clock online resident tools. Nestled in a vibrant neighborhood, our apartments provide the perfect balance of tranquility and easy access to educational pursuits. Experience the convenience and comfort of Homestead, and make the most of your academic journey at Dallas College Richland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Dallas College Richland",
      "seo_description": "Find Homestead apartments close to Dallas College Richland in Garland, TX, offering convenience and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "garland-apartments-near-collin-college-spring-creek",
      "search_query": "garland apartments near collin college spring creek",
      "category": "School",
      "h1_title": "Garland Apartments Near Collin College",
      "h2_subtitle": "Discover Homestead's ideal Garland apartments near Collin College Spring Creek. Enjoy stylish living just minutes from campus.",
      "page_copy": "Homestead provides exceptional apartment living just a short distance from Collin College Spring Creek in Garland, TX. Our community caters to those looking for modern studio, one, two, and three-bedroom apartments with upscale finishes and a welcoming atmosphere. Perfect for students and educators, Homestead combines comfort with a prime location for easy access to educational pursuits.\n\nExperience the convenience of amenities like tailored air conditioning, efficient trash service from your door, and online resident access available at any time. Relish in the blend of tranquility and campus connectivity that Homestead offers, making it the perfect choice for those who want both vibrant academic opportunities and a serene home setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Garland Apartments Near Collin College",
      "seo_description": "Explore stylish apartments at Homestead near Collin College Spring Creek in Garland, TX, with premium amenities and accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartment-living-near-collin-college-wylie",
      "search_query": "apartment living near collin college wylie",
      "category": "School",
      "h1_title": "Apartment Living Near Collin College Wylie",
      "h2_subtitle": "Experience modern apartment living near Collin College Wylie at Homestead, offering luxury amenities and convenient access.",
      "page_copy": "Homestead delivers an exceptional apartment living experience near Collin College Wylie. Our community offers an attractive selection of studio, one, two, and three-bedroom homes that combine elegant designer finishes with the comfort of a cozy home environment. Ideal for students and faculty, Homestead is perfectly situated for those wanting the balance of academic convenience and a peaceful retreat.\n\nEnjoy a lifestyle enriched by amenities such as climate-controlled air conditioning, a reliable door-to-door trash pick-up service, and 24/7 online resident tools. Nestled within the vibrant Garland community, Homestead provides the ideal backdrop for both educational pursuits and leisure activities. Make Homestead your choice for a delightful blend of comfort and accessibility near Collin College Wylie.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Collin College Wylie",
      "seo_description": "Discover luxury apartment living near Collin College Wylie at Homestead in Garland, with premium amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartments-nearby-west-coast-university-texas",
      "search_query": "apartments nearby west coast university texas",
      "category": "School",
      "h1_title": "Apartments Nearby West Coast University Texas",
      "h2_subtitle": "Explore Homestead's charming apartments nearby West Coast University Texas, featuring luxurious amenities in a prime Garland location.",
      "page_copy": "Discover the perfect home at Homestead, offering apartments conveniently located near West Coast University Texas. Our community provides a selection of studio, one, two, and three-bedroom residences tailored with exquisite designer touches and modern amenities. Homestead is the ideal choice for students and staff seeking convenient access to the university along with a serene living environment.\n\nAt Homestead, enjoy the luxury of amenities such as efficient air conditioning, a door-to-door trash service, and comprehensive 24-hour online resident services. Located in the vibrant Garland area, Homestead offers the perfect mix of academic proximity and comfortable living spaces. Make the most of your educational journey with a home that supports both studies and leisure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Nearby West Coast University Texas",
      "seo_description": "Find Homestead apartments close to West Coast University Texas, featuring upscale amenities and a great Garland location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartments-near-garland-va-medical-center",
      "search_query": "apartments near Garland VA Medical Center Dallas County",
      "category": "Hospital",
      "h1_title": "Apartments Near Garland VA Medical Center",
      "h2_subtitle": "Discover Homestead's prime apartments near Garland VA Medical Center, offering modern amenities in a convenient Dallas County location.",
      "page_copy": "Homestead offers excellent apartment living close to the Garland VA Medical Center in Dallas County. Our stylish studio, one, two, and three-bedroom apartments are designed with sophisticated finishes and top-notch amenities, catering to those working at or visiting the medical center. Benefit from convenient proximity while enjoying the peace and comfort of a welcoming home environment.\n\nOur residents enjoy perks like robust air conditioning, efficient door-to-door trash pickup, and the convenience of 24-hour online resident services. Nestled within the thriving Garland community, Homestead provides a superb residence that complements the professional needs of healthcare workers and visitors while ensuring a restful retreat. Choose Homestead for a living experience that balances work and relaxation seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Garland VA Medical Center",
      "seo_description": "Explore Homestead apartments near Garland VA Medical Center with luxe amenities and easy access to Dallas County's healthcare hub.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartments-near-prairie-creek-waterfall-garland",
      "search_query": "apartments near Prairie Creek Waterfall Garland",
      "category": "Park",
      "h1_title": "Apartments Near Prairie Creek Waterfall Garland",
      "h2_subtitle": "Explore the serenity of Homestead's apartments near Prairie Creek Waterfall Garland, offering an ideal blend of nature and luxury living.",
      "page_copy": "Homestead is your gateway to nature-infused living with our apartments conveniently situated near Prairie Creek Waterfall in Garland. Choose from our elegant studio, one, two, and three-bedroom homes that feature chic designer details along with a range of modern amenities. These homes are perfect for those who appreciate the beauty of nature and the luxury of a well-appointed living environment.\n\nResidents of Homestead are treated to outstanding amenities like efficient air conditioning, a dependable door-to-door trash service, and the ease of 24-hour online resident tools. Situated in a vibrant neighborhood, Homestead presents a unique locale that perfectly complements the tranquil backdrop of Prairie Creek Waterfall. Experience the perfect harmony of natural beauty and refined comfort at Homestead.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Prairie Creek Waterfall Garland",
      "seo_description": "Discover Homestead apartments near Prairie Creek Waterfall Garland with luxurious amenities and natural surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartments-close-to-breckinridge-park-richardson-tx",
      "search_query": "apartments close to Breckinridge Park Richardson TX",
      "category": "Park",
      "h1_title": "Apartments Close to Breckinridge Park Richardson",
      "h2_subtitle": "Find tranquility and convenience at Homestead's apartments close to Breckinridge Park in Richardson, TX, featuring upscale amenities and modern designs.",
      "page_copy": "Located just a short distance from Breckinridge Park in Richardson, TX, Homestead offers a selection of stylish studio, one, two, and three-bedroom apartments. These residences provide a perfect blend of natural beauty and urban amenities, ideal for those who enjoy outdoor activities and modern conveniences. With Breckinridge Park close by, easy access to trails and picturesque landscapes is just one of the many benefits of living at Homestead.\n\nOur community is enriched with top-tier amenities like robust air conditioning, hassle-free door-to-door trash pickup, and user-friendly 24-hour online resident services. Nestled in Garland, near the vibrant city of Richardson, Homestead is the ideal residential choice for those seeking both relaxation and convenience. Make Homestead your home and embrace the essence of comfortable and serene living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Breckinridge Park Richardson",
      "seo_description": "Discover Homestead apartments close to Breckinridge Park Richardson, offering luxury living and nature access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartments-near-dart-light-rail-plano-station",
      "search_query": "apartments near dart light rail downtown plano station",
      "category": "Transit",
      "h1_title": "Apartments Near DART Light Rail Plano Station",
      "h2_subtitle": "Experience convenient connectivity at Homestead's apartments near DART Light Rail Downtown Plano Station, blending comfort and accessibility.",
      "page_copy": "Discover exceptional living at Homestead, where our apartments are strategically located near the DART Light Rail Downtown Plano Station. Choose from our meticulously designed studio, one, two, and three-bedroom homes that offer the perfect balance of comfort and convenience. Ideal for those relying on quick transit options, Homestead places you within easy reach of all that Plano and its surroundings have to offer.\n\nOur community boasts superior amenities such as reliable air conditioning, a convenient door-to-door trash pickup service, and efficient 24-hour online resident management. Situated in a thriving neighborhood with direct access to the DART Light Rail, Homestead ensures that navigating the city is both effortless and enjoyable. Experience the advantage of connectivity coupled with luxurious apartment living at Homestead.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near DART Light Rail Plano Station",
      "seo_description": "Explore Homestead apartments near DART Light Rail Plano Station, offering seamless city access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "garland-tx-apartments-downtown-transit",
      "search_query": "garland tx apartments by downtown garland transit",
      "category": "Transit",
      "h1_title": "Garland TX Apartments by Downtown Transit",
      "h2_subtitle": "Discover ultimate convenience at Homestead's Garland TX apartments by Downtown Garland Transit, offering ease and luxury in one place.",
      "page_copy": "At Homestead, experience modern living with unparalleled access to downtown Garland's vibrant transit system. Our studio, one, two, and three-bedroom apartments in Garland, TX, provide an ideal setting for those who prioritize connectivity and luxury. Located near Downtown Garland Transit, Homestead ensures you're always minutes away from the city's prime destinations, making daily commutes easy and efficient.\n\nOur community offers an array of amenities, including efficient air conditioning, a dependable door-to-door trash service, and a comprehensive 24/7 online resident service portal. Situated in the heart of Garland, Homestead provides a living experience that combines the best of urban accessibility with high-quality apartment features. Embrace the simplicity of city life at Homestead, where convenience meets comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Garland TX Apartments by Downtown Transit",
      "seo_description": "Discover Homestead apartments in Garland TX by Downtown Transit, offering luxury living with easy commutes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "homestead-apts-near-spring-valley-transport",
      "search_query": "homestead apts near spring valley transportation",
      "category": "Transit",
      "h1_title": "Homestead Apts Near Spring Valley Transport",
      "h2_subtitle": "Enjoy easy commutes from Homestead apts near Spring Valley transportation, blending modern amenities with strategic location.",
      "page_copy": "Welcome to Homestead, where premier living meets effortless commuting with our proximity to Spring Valley transportation hubs. Choose from our beautifully appointed studio, one, two, and three-bedroom apartments that blend comfort and style. Situated near major transit lines, Homestead ensures that whether you're heading to work or exploring the area, getting there is a breeze.\n\nOur community is packed with exceptional amenities designed for your convenience, including advanced air conditioning systems, door-to-door trash service, and accessible 24-hour online resident services. Located in Garland, Homestead is the ideal choice for those who value modern living with quick access to Spring Valley's transport routes. Immerse yourself in the best of city living, right at Homestead.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Homestead Apts Near Spring Valley Transport",
      "seo_description": "Find Homestead apts near Spring Valley transportation, offering modern amenities and easy commutes in Garland, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "garland-forest-jupiter-proximity-apartments",
      "search_query": "garland forest jupiter transit proximity apartments",
      "category": "Transit",
      "h1_title": "Garland Forest Jupiter Transit Proximity Apts",
      "h2_subtitle": "Live conveniently at Homestead, where our Garland apartments offer easy access to Forest Jupiter transit and all the comforts of home.",
      "page_copy": "Discover your ideal home at Homestead, set in a vibrant neighborhood with perfect proximity to Forest Jupiter transit. Our studio, one, two, and three-bedroom apartments in Garland provide an exceptional location for those who value prompt transportation options and comfortable living. Enjoy seamless connectivity to the city's prime spots while residing in a luxurious community designed with you in mind.\n\nHomestead offers an array of top-tier amenities such as consistent air conditioning, a convenient door-to-door trash pickup, and a user-friendly 24-hour online resident service platform. Positioned near key transit lines, our community ensures easy accessibility, allowing you to experience the best that Garland has to offer. Choose Homestead for an unparalleled living experience that combines comfort with ideal transit positioning.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Garland Forest Jupiter Transit Proximity Apts",
      "seo_description": "Homestead offers Garland apartments with Forest Jupiter transit nearby, providing luxury and connectivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167743",
      "source": "generator",
      "page_item_url": "apartments-close-lbj-skillman-transit-hub",
      "search_query": "apartments close to lbj skillman transit hub",
      "category": "Transit",
      "h1_title": "Apartments Close to LBJ Skillman Transit Hub",
      "h2_subtitle": "Enjoy the ease of living at Homestead, with apartments close to LBJ Skillman Transit Hub. Perfect for those seeking comfort and accessibility.",
      "page_copy": "Choose Homestead for its prime location and unparalleled convenience. Our studio, one, two, and three-bedroom apartments are not only stylishly designed but are also ideally situated close to the LBJ Skillman Transit Hub. This prime positioning means that commuting is smooth and stress-free, providing easy access to the city's pivotal destinations.\n\nAt Homestead, indulge in a suite of amenities such as efficient air conditioning, comprehensive door-to-door trash services, and a reliable 24-hour online resident platform. Living close to the LBJ Skillman Transit Hub places you in the heart of accessibility, making Homestead the perfect choice for those who value both convenience and luxury in their living spaces. Experience the seamless blend of connectivity and comfort at Homestead.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees in a modern apartment complex.",
        "public_id": "01a03e59-ece5-7388-a733-0a35513051a7",
        "storage_key": "property/6767906449167743/01a03e59-ece5-7388-a733-0a35513051a7.webp",
        "width": 1728,
        "height": 1152
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to LBJ Skillman Transit Hub",
      "seo_description": "Homestead offers Garland apartments close to the LBJ Skillman Transit Hub, combining luxury living with prime transportation access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ii9wcHR0clFZMHRVejZXYnhSb0g0amc9PSIsInZhbHVlIjoieTI1VmUwdGp2c2FOU3dTaWluSXUzUT09IiwibWFjIjoiNjQzYzQ0NjBkMGM2NDliNmJjYTllMjQxNTYwYjNiOTIwNjI3ZWM4ZjEzM2QyMzUwZjU3YTRlNzJiNGI5MGYxOSJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ii9wcHR0clFZMHRVejZXYnhSb0g0amc9PSIsInZhbHVlIjoieTI1VmUwdGp2c2FOU3dTaWluSXUzUT09IiwibWFjIjoiNjQzYzQ0NjBkMGM2NDliNmJjYTllMjQxNTYwYjNiOTIwNjI3ZWM4ZjEzM2QyMzUwZjU3YTRlNzJiNGI5MGYxOSJ9",
  "custom_audioeye_site_id": "03d05877-b48e-4e87-ad52-e893e1b20e6b",
  "custom_audioeye_site_hash": "579931c5855e3cd4c9a15d68d54cc9ed"
};

export const generatedAt = '2026-08-26T14:38:21.440Z';
